import Swiper from "./swiper-bundle.esm.browser.min.js";

const BUNDLE_V2_URL_KEYS = Object.freeze({
  items: "bundle_v2",
  index: "bundle_v2_index",
  interval: "bundle_v2_interval",
  frequency: "bundle_v2_interval_frequency",
});

const BUNDLE_V2_LEGACY_URL_KEYS = Object.freeze({
  items: "bundle",
  index: "bundle_index",
  interval: "bundle_interval",
  frequency: "bundle_interval_frequency",
});

const BUNDLE_V2_STORAGE_PREFIX = "lsgBundleStateV2";
const BUNDLE_V2_LEGACY_STORAGE_PREFIX = "lsgBundleState";

const BUNDLE_V2_CART_SNAPSHOT_KEYS = Object.freeze({
  snapshot: "__lsgBundleV2CartSnapshot",
  snapshotAt: "__lsgBundleV2CartSnapshotAt",
  snapshotPromise: "__lsgBundleV2CartSnapshotPromise",
});

const BUNDLE_V2_ATC_DEDUPE_KEYS = Object.freeze({
  signature: "__bundleV2AtcEventSignature",
  time: "__bundleV2AtcEventTime",
});

class StayAIBundleBuilder extends HTMLElement {
  constructor() {
    super();
    const bundleBlocks = document.querySelectorAll(".lsg-bundle-v2-block");
    this.productSelectionButtonClicked = false;
    this.productSelectionIndex = "";
    this.selectedProducts = bundleBlocks.length > 0
      ? [...bundleBlocks].map(() => [...[]])
      : this.selectedProducts;
    this.v2Mode = "single";
    this.v2StructureChosen = true;
    this.v2SingleQuantity = 1;
    this.v2BundleQuantity = 1;
    this.v2SingleVariantId = "";
    this.v2BundleSlots = ["", "", ""];
    this.v2ActiveSlot = -1;
    this.v2PlanWasUnlocked = false;
    this.v2FlowBound = false;
    this.v2FlowInitialized = false;
  }
}
if (!customElements.get("stay-ai-bundle-builder-v2")) {
  customElements.define("stay-ai-bundle-builder-v2", StayAIBundleBuilder);
}

class StayAIBundleProduct extends StayAIBundleBuilder {
  constructor() {
    super();
    this.productJSON = this.getAttribute("product");
    this.product = JSON.parse(this.productJSON);
    this.bundleIndex = this.getAttribute("bundle-index");
    const bundleMin = Number(this.getAttribute("bundle-min"));
    const bundleMax = Number(this.getAttribute("bundle-max"));
    this.bundleMin = Number.isFinite(bundleMin) ? bundleMin : 0;
    this.bundleMax = Number.isFinite(bundleMax) && bundleMax > 0 ? bundleMax : 0;
    this.cart = document.querySelector("cart-drawer");
    this.bundleTextConfig = {};
  }
  connectedCallback() {
    this.addToCartButton = this.querySelector("[data-bundle-atc]");
    this.addToCartButtonQuantity = this.querySelector("[data-bundle-atc-missing-quantity]");
    this.selectedProductsWrapper = this.querySelectorAll("[data-bundle-builder-selected-products]")
    this.selectedVariantWrapper = this.querySelectorAll("[data-bundle-builder-selected-variant-id]");
    this.productModal = this.querySelector("[data-bundle-product-modal]");
    this.productModalGallery = this.productModal?.querySelector("[data-bundle-product-modal-gallery]") || null;
    this.productModalTrack = this.productModal?.querySelector("[data-bundle-product-modal-track]") || null;
    this.productModalDots = this.productModal?.querySelector("[data-bundle-product-modal-dots]") || null;
    this.productModalTitle = this.productModal?.querySelector("[data-bundle-product-modal-title]") || null;
    this.productModalDescription = this.productModal?.querySelector("[data-bundle-product-modal-description]") || null;
    this.productModalCalories = this.productModal?.querySelector("[data-bundle-product-modal-calories]") || null;
    this.productModalAddButton = this.productModal?.querySelector("[data-bundle-product-modal-add]") || null;
    this.stickyBar = this.querySelector("[data-bundle-sticky-bar]") || null;
    this.stickyViewToggle = this.querySelector("[data-bundle-sticky-view-toggle]") || null;
    this.stickyViewPanel = this.querySelector("[data-bundle-sticky-view-panel]") || null;
    this.stickyTotalEl = this.querySelector("[data-bundle-sticky-total]") || null;
    this.stickyCompareTotalEl = this.querySelector("[data-bundle-sticky-compare-total]") || null;
    this.stickySaveEl = this.querySelector("[data-bundle-sticky-save]") || null;
    this.stickySubSaveEls = Array.from(this.querySelectorAll("[data-bundle-sticky-subsave]"));
    this.stickyUnlockedEl = this.querySelector("[data-bundle-sticky-unlocked]") || null;
    this.stickyProgressEls = Array.from(this.querySelectorAll("[data-bundle-sticky-progress]"));
    this.showcaseRoot = this.querySelector("[data-bundle-showcase]") || null;
    this.showcaseSwiperEl = this.querySelector("[data-bundle-showcase-swiper]") || null;
    this.showcaseTrack = this.querySelector("[data-bundle-showcase-track]") || null;
    this.showcaseMainImage = this.querySelector("[data-bundle-showcase-main-image]") || null;
    this.showcaseThumbs = this.querySelector("[data-bundle-showcase-thumbs]") || null;
    this.showcaseDots = this.querySelector("[data-bundle-showcase-dots]") || null;
    this.showcaseFlavors = this.querySelector("[data-bundle-showcase-flavors]") || null;
    this.showcasePrevButton = this.querySelector("[data-bundle-showcase-prev]") || null;
    this.showcaseNextButton = this.querySelector("[data-bundle-showcase-next]") || null;
    this.showcaseZoom = this.querySelector("[data-bundle-showcase-zoom]") || null;
    this.showcaseZoomImage = this.showcaseZoom?.querySelector("[data-bundle-showcase-zoom-image]") || null;
    this.showcaseZoomToggle = this.showcaseZoom?.querySelector("[data-bundle-showcase-zoom-toggle]") || null;
    this.showcaseActiveCard = null;
    this.showcaseSlides = [];
    this.showcaseSlideIndex = 0;
    this.showcaseZoomScale = 1;
    this.showcaseSwiper = null;
    this.showcaseSwiperSyncing = false;
    this.productModalGalleryLength = 0;
    this.modalGalleryIndex = 0;
    this.productModalSwiper = null;
    this.modalActiveCard = null;
    this.showcaseImagePreloadCache = new Set();
    this.boundModalKeydown = this.handleModalKeydown.bind(this);
    this.boundShowcaseZoomKeydown = this.handleShowcaseZoomKeydown.bind(this);
    this.boundShowcaseKeydown = this.handleShowcaseKeydown.bind(this);
    this.currentBundleTotalFormatted = "";
    this.lastOtpSubtotal = 0;
    this.lastSubSubtotal = 0;
    this.lastCompareSubtotal = 0;
    this.lastSavingsSubtotal = 0;
    this.lastOtpDiscountPercent = 0;
    this.lastSubDiscountPercent = 0;
    this.hasRequiredProductQuantity = false;
    this.isAddingToCart = false;
    this.atcProgressState = "idle";
    this.atcProgressTimer = 0;
    this.isRestoringPersistedState = false;
    this.stickyOfferRaf = 0;
    this.pendingStickyOfferPayload = null;
    this.lastStickyOfferSnapshot = "";
    this.boundStickyViewportUpdate = () => this.requestStickyOfferBarUpdate();
    this.boundHintLabelUpdate = () => this.updateCardHintLabels();
    this.cartSyncRetryTimer = 0;
    this.cartSyncRetryLongTimer = 0;
    this.lastCartStateSyncAt = 0;
    this.bundleTextConfig = this.getBundleTextConfig();

    this.loadEventListeners();
    this.initializeBundle();
    this.loadBundleObserver();
    this.checkStickyAtcVisibility();

    // Preselect first interval option
    // this.querySelectorAll('.lsg-bundle-v2-interval-select input[name^="bundle_interval_select_"]')[0].checked = true
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.boundStickyViewportUpdate);
    window.removeEventListener("resize", this.boundStickyViewportUpdate);
    if (this.planSummaryUpdate) {
      window.removeEventListener("scroll", this.planSummaryUpdate);
      window.removeEventListener("resize", this.planSummaryUpdate);
    }
    window.removeEventListener("resize", this.boundHintLabelUpdate);
    document.removeEventListener("keydown", this.boundModalKeydown);
    document.removeEventListener("keydown", this.boundShowcaseZoomKeydown);
    if (this.showcaseRoot) {
      this.showcaseRoot.removeEventListener("keydown", this.boundShowcaseKeydown);
    }
    document.body.classList.remove("lsg-bundle-v2-showcase-zoom-open");
    if (this.cartSyncRetryTimer) {
      window.clearTimeout(this.cartSyncRetryTimer);
      this.cartSyncRetryTimer = 0;
    }
    if (this.cartSyncRetryLongTimer) {
      window.clearTimeout(this.cartSyncRetryLongTimer);
      this.cartSyncRetryLongTimer = 0;
    }
    if (this.stickyOfferRaf) {
      window.cancelAnimationFrame(this.stickyOfferRaf);
      this.stickyOfferRaf = 0;
    }
    if (this.atcProgressTimer) {
      window.clearTimeout(this.atcProgressTimer);
      this.atcProgressTimer = 0;
    }
    this.destroyShowcaseSwiper();
    this.destroyProductModalSwiper();
  }

  initializeBundle() {
    const intervalSelect = this.querySelector('.lsg-bundle-v2-interval-select');
    const sellingPlanInput = this.querySelector('.lsg-bundle-v2-form input[name="selling_plan"]');
    const frequencySelect = this.querySelector('.lsg-bundle-v2-interval-frequency-select');
    const bundleProductSetList = this.querySelectorAll(".stay-ai-bundle-product-v2__cards");
    const hasQueryState = this.hasBundleParamsInUrl();

    this.sortFrequencySelects();
    
    if(intervalSelect){
      this.classList.add('lsg-bundle-v2--has-interval-select');
      let selectedIntervalWrapper = intervalSelect.querySelector('input[name^="bundle_interval_select_"]:checked');
      if (!selectedIntervalWrapper) {
        selectedIntervalWrapper = intervalSelect.querySelector('input[name^="bundle_interval_select_"][value="sub"]')
          || intervalSelect.querySelector('input[name^="bundle_interval_select_"][value="otp"]');
        if (selectedIntervalWrapper) {
          selectedIntervalWrapper.checked = true;
        }
      }

      const selectedInterval = selectedIntervalWrapper?.value || '';
      const hasSubscriptionInterval = selectedInterval === 'otp' || selectedInterval === 'sub';
      if (hasSubscriptionInterval) {
        const isOneTimePurchase = selectedInterval === 'otp';
        const intervalSelectorClass = isOneTimePurchase ? 'lsg-bundle-v2--otp-selected' : 'lsg-bundle-v2--sub-selected';

        this.classList.add(intervalSelectorClass)
        const frequencyValue = frequencySelect ? frequencySelect.value : "";
        if (sellingPlanInput) {
          sellingPlanInput.value = isOneTimePurchase ? "" : frequencyValue;
        }
        if (frequencySelect) {
          this.syncFrequencySelects(frequencyValue);
        }
      }
    }

    bundleProductSetList.forEach((productSetList) => {
      productSetList.querySelectorAll('.stay-ai-bundle-product-v2__quantity').forEach((quantityInput) => {
        this.updateQuantityDisplay(quantityInput);
      });
      this.totalSelectedQtyValidation();
    });

    this.updateBundlePrice();
    this.checkoutEnableValidation(sellingPlanInput);
    this.updatePlanSummary();
    this.updateFlavorSelectionHelper();
    this.updateStickySummary();
    this.initializeShowcase();
    this.updateCardHintLabels();
    this.setupPlanSummaryObserver();
    if (hasQueryState) {
      this.checkParameter();
    } else {
      this.restoreBundleState();
    }
    this.initializeMobileFlowV2();
    this.classList.add('is-initialized');
    this.scrollPlanIntoView();
  }

  isV2MobileFlowEnabled() {
    return this.classList.contains("lsg-bundle-v2-mobile-flow-enabled");
  }

  initializeMobileFlowV2() {
    this.v2MobileFlowRoot = this.querySelector("[data-bundle-v2-mobile-flow]");
    if (!this.v2MobileFlowRoot) return;

    this.classList.add("lsg-bundle-v2-mobile-flow-enabled");

    this.v2StructureButtons = Array.from(this.querySelectorAll("[data-bundle-v2-structure-option]"));
    this.v2FlavorStep = this.querySelector("[data-bundle-v2-flavor-step]");
    this.v2SlotStep = this.querySelector("[data-bundle-v2-slot-step]");
    this.v2SlotWrappers = Array.from(this.querySelectorAll("[data-bundle-v2-slot-wrapper]"));
    this.v2SlotButtons = Array.from(this.querySelectorAll("[data-bundle-v2-slot-button]"));
    this.v2SlotValueEls = Array.from(this.querySelectorAll("[data-bundle-v2-slot-value]"));
    this.v2SlotClearButtons = Array.from(this.querySelectorAll("[data-bundle-v2-slot-clear]"));
    this.v2SlotEmptyEls = Array.from(this.querySelectorAll("[data-bundle-v2-slot-empty]"));
    this.v2SlotSelectedEls = Array.from(this.querySelectorAll("[data-bundle-v2-slot-selected]"));
    this.v2SlotImageEls = Array.from(this.querySelectorAll("[data-bundle-v2-slot-image]"));
    this.v2SlotSwatchEls = Array.from(this.querySelectorAll("[data-bundle-v2-slot-swatch]"));
    this.v2SlotOptionContainers = Array.from(this.querySelectorAll("[data-bundle-v2-slot-options]"));
    this.v2SlotCounter = this.querySelector("[data-bundle-v2-slot-counter]");
    this.v2SlotProgressFill = this.querySelector("[data-bundle-v2-slot-progress-fill]");
    this.v2PlanStep = this.querySelector("[data-bundle-v2-plan-step]");
    this.v2AddStep = this.querySelector("[data-bundle-v2-add-step]");
    this.v2SingleQtyWrap = this.querySelector("[data-bundle-v2-single-qty-wrap]");
    this.v2BundleQtyWrap = this.querySelector("[data-bundle-v2-bundle-qty-wrap]");
    this.v2SingleQtyValueEl = this.querySelector("[data-bundle-v2-single-qty-value]");
    this.v2BundleQtyValueEl = this.querySelector("[data-bundle-v2-bundle-qty-value]");
    this.v2SingleFlavorPicker = this.querySelector("[data-bundle-v2-single-flavor-picker]");
    this.v2FlavorOptions = this.collectV2FlavorOptions();

    if (!this.v2FlowBound) {
      this.bindMobileFlowV2Events();
      this.v2FlowBound = true;
    }

    this.hydrateV2FlowStateFromInputs();
    this.renderV2SlotOptions();
    this.renderV2SingleFlavorOptions();
    this.updateV2FlowUi();
  }

  bindMobileFlowV2Events() {
    this.v2StructureButtons?.forEach((button) => {
      button.addEventListener("click", () => {
        const selectedMode = button.dataset.bundleV2StructureOption === "bundle" ? "bundle" : "single";
        this.setV2Mode(selectedMode);
      });
    });

    this.v2SlotButtons?.forEach((button) => {
      button.addEventListener("click", () => {
        const slotIndex = Number(button.dataset.bundleV2Slot);
        if (!Number.isFinite(slotIndex)) return;
        this.selectV2Slot(slotIndex);
      });
    });

    this.v2SlotClearButtons?.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        const slotIndex = Number(button.dataset.bundleV2Slot);
        if (!Number.isFinite(slotIndex)) return;
        this.clearV2Slot(slotIndex);
      });
    });

    this.v2SlotOptionContainers?.forEach((container) => {
      container.addEventListener("click", (event) => {
        const optionButton = event.target.closest("[data-bundle-v2-slot-option]");
        if (!optionButton || !container.contains(optionButton)) return;
        event.preventDefault();
        event.stopPropagation();
        const slotIndex = Number(optionButton.dataset.bundleV2Slot);
        const variantId = String(optionButton.dataset.bundleV2Variant || "").trim();
        if (!Number.isFinite(slotIndex) || !variantId) return;
        this.setV2SlotVariant(slotIndex, variantId);
      });
    });

    if (this.v2SingleFlavorPicker) {
      this.v2SingleFlavorPicker.addEventListener("click", (event) => {
        const optionButton = event.target.closest("[data-bundle-v2-single-flavor-option]");
        if (!optionButton || !this.v2SingleFlavorPicker.contains(optionButton)) return;
        event.preventDefault();
        const variantId = String(optionButton.dataset.bundleV2Variant || "").trim();
        if (!variantId) return;
        this.setV2SingleFlavorVariant(variantId);
      });
    }

    const singleMinusButton = this.querySelector("[data-bundle-v2-single-qty-minus]");
    const singlePlusButton = this.querySelector("[data-bundle-v2-single-qty-plus]");
    const bundleMinusButton = this.querySelector("[data-bundle-v2-bundle-qty-minus]");
    const bundlePlusButton = this.querySelector("[data-bundle-v2-bundle-qty-plus]");

    if (singleMinusButton) {
      singleMinusButton.addEventListener("click", (event) => {
        event.preventDefault();
        this.adjustV2Quantity("single", -1);
      });
    }
    if (singlePlusButton) {
      singlePlusButton.addEventListener("click", (event) => {
        event.preventDefault();
        this.adjustV2Quantity("single", 1);
      });
    }
    if (bundleMinusButton) {
      bundleMinusButton.addEventListener("click", (event) => {
        event.preventDefault();
        this.adjustV2Quantity("bundle", -1);
      });
    }
    if (bundlePlusButton) {
      bundlePlusButton.addEventListener("click", (event) => {
        event.preventDefault();
        this.adjustV2Quantity("bundle", 1);
      });
    }

    this.querySelectorAll(".lsg-bundle-v2-flavors-grid .lsg-bundle-v2-product-select-wrapper").forEach((productCard) => {
      productCard.addEventListener("click", (event) => {
        if (event.target.closest("[data-bundle-product-info-open]")) return;
        this.handleV2FlavorCardSelect(productCard);
      });
    });

    this.querySelectorAll(".lsg-bundle-v2-product-select-quantity-plus").forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        const productCard = button.closest(".lsg-bundle-v2-product-select-wrapper");
        if (!productCard) return;
        this.handleV2FlavorCardSelect(productCard);
      }, { capture: true });
    });

    this.querySelectorAll(".lsg-bundle-v2-product-select-quantity-minus").forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        const productCard = button.closest(".lsg-bundle-v2-product-select-wrapper");
        const variantId = String(productCard?.getAttribute("data-lsg-bundle-v2-variant-select-id") || "").trim();
        if (!variantId) return;
        this.clearV2SelectionByVariantId(variantId);
      }, { capture: true });
    });
  }

  setV2Mode(mode = "single") {
    if (!this.isV2MobileFlowEnabled()) return;
    const normalizedMode = mode === "bundle" ? "bundle" : "single";
    const hasModeChanged = this.v2Mode !== normalizedMode;
    this.v2StructureChosen = true;
    if (!hasModeChanged) {
      this.updateV2FlowUi();
      this.persistBundleState();
      return;
    }

    this.v2Mode = normalizedMode;
    if (normalizedMode === "single") {
      if (!this.v2SingleVariantId && this.v2BundleSlots[0]) {
        this.v2SingleVariantId = this.v2BundleSlots[0];
      }
      this.v2ActiveSlot = -1;
    } else {
      if (!this.v2BundleSlots[0] && this.v2SingleVariantId) {
        this.v2BundleSlots[0] = this.v2SingleVariantId;
      }
      this.v2ActiveSlot = -1;
    }

    this.applyV2FlowState();
    this.persistBundleState();
  }

  selectV2Slot(slotIndex) {
    if (!this.isV2MobileFlowEnabled() || !this.v2StructureChosen || this.v2Mode !== "bundle") return;
    if (!Number.isFinite(slotIndex) || slotIndex < 0 || slotIndex > 2) return;
    const firstTwoSelected = Boolean(this.v2BundleSlots[0] && this.v2BundleSlots[1]);
    if (slotIndex === 2 && !firstTwoSelected) return;
    this.v2ActiveSlot = slotIndex;
    this.updateV2FlowUi();
    this.persistBundleState();
  }

  clearV2Slot(slotIndex) {
    if (!this.isV2MobileFlowEnabled() || !this.v2StructureChosen || this.v2Mode !== "bundle") return;
    if (!Number.isFinite(slotIndex) || slotIndex < 0 || slotIndex > 2) return;

    this.v2BundleSlots[slotIndex] = "";
    if (slotIndex < 2) {
      this.v2BundleSlots[2] = "";
    }
    this.v2ActiveSlot = slotIndex < 2 ? slotIndex : this.getNextV2OpenSlotIndex();
    this.applyV2FlowState();
    this.persistBundleState();
  }

  collectV2FlavorOptions() {
    const flavorCards = Array.from(
      this.querySelectorAll(".lsg-bundle-v2-flavors-grid .lsg-bundle-v2-product-select-wrapper"));
    return flavorCards
      .map((card) => {
        const variantId = String(card.getAttribute("data-lsg-bundle-v2-variant-select-id") || "").trim();
        if (!variantId) return null;
        const label = String(card.dataset.bundleCardTitle || "")
          .trim()
          || String(card.querySelector(".lsg-bundle-v2-product-select-title")?.textContent || "").trim();
        const imageEl = card.querySelector(".lsg-bundle-v2-product-select-img-wrap img");
        return {
          variantId,
          label,
          color: String(card.dataset.bundleFlavorHex || "").trim() || "#94a3b8",
          image: String(imageEl?.getAttribute("src") || "").trim(),
          imageAlt: String(imageEl?.getAttribute("alt") || label || "").trim(),
        };
      })
      .filter(Boolean);
  }

  getV2FlavorMetaByVariantId(variantId = "") {
    const normalizedVariantId = String(variantId || "").trim();
    if (!normalizedVariantId) return null;
    const cachedMatch = (this.v2FlavorOptions || []).find((option) => option.variantId === normalizedVariantId);
    if (cachedMatch) return cachedMatch;
    const fallbackCard = this.querySelector(
      `.lsg-bundle-v2-product-select-wrapper[data-lsg-bundle-v2-variant-select-id="${normalizedVariantId}"]`);
    if (!fallbackCard) return null;
    const fallbackImage = fallbackCard.querySelector(".lsg-bundle-v2-product-select-img-wrap img");
    return {
      variantId: normalizedVariantId,
      label: this.getBundleFlavorLabelByVariantId(normalizedVariantId),
      color: String(fallbackCard.dataset.bundleFlavorHex || "").trim() || "#94a3b8",
      image: String(fallbackImage?.getAttribute("src") || "").trim(),
      imageAlt: String(fallbackImage?.getAttribute("alt") || "").trim(),
    };
  }

  renderV2SlotOptions() {
    if (!this.isV2MobileFlowEnabled() || !Array.isArray(this.v2SlotOptionContainers)) return;

    this.v2SlotOptionContainers.forEach((container) => {
      const slotIndex = Number(container.dataset.bundleV2Slot);
      if (!Number.isFinite(slotIndex)) return;
      container.innerHTML = "";

      (this.v2FlavorOptions || []).forEach((option) => {
        const optionButton = document.createElement("button");
        optionButton.type = "button";
        optionButton.className = "lsg-bundle-v2-slot-option";
        optionButton.dataset.bundleV2SlotOption = "true";
        optionButton.dataset.bundleV2Slot = String(slotIndex);
        optionButton.dataset.bundleV2Variant = option.variantId;

        const swatch = document.createElement("span");
        swatch.className = "lsg-bundle-v2-slot-option__swatch";
        swatch.style.backgroundColor = option.color;
        optionButton.appendChild(swatch);

        const label = document.createElement("span");
        label.className = "lsg-bundle-v2-slot-option__label";
        label.textContent = option.label || this.getBundleText("fallbackFlavorLabelText", "Flavor");
        optionButton.appendChild(label);
        container.appendChild(optionButton);
      });
    });
  }

  renderV2SingleFlavorOptions() {
    if (!this.v2SingleFlavorPicker) return;

    this.v2SingleFlavorPicker.innerHTML = "";
    const options = Array.isArray(this.v2FlavorOptions) ? this.v2FlavorOptions : [];
    if (!options.length) return;

    const createOptionButton = (option) => {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "lsg-bundle-v2-single-flavor-option";
      button.dataset.bundleV2SingleFlavorOption = "true";
      button.dataset.bundleV2Variant = option.variantId;

      const check = document.createElement("span");
      check.className = "lsg-bundle-v2-single-flavor-option__check";
      check.setAttribute("aria-hidden", "true");
      check.innerHTML = `
        <svg viewBox="0 0 24 24" focusable="false">
          <path d="M20 6 9 17l-5-5"></path>
        </svg>
      `;
      button.appendChild(check);

      const swatch = document.createElement("span");
      swatch.className = "lsg-bundle-v2-single-flavor-option__swatch";
      swatch.style.backgroundColor = option.color || "#94a3b8";
      button.appendChild(swatch);

      const label = document.createElement("span");
      label.className = "lsg-bundle-v2-single-flavor-option__label";
      label.textContent = option.label || this.getBundleText("fallbackFlavorLabelText", "Flavor");
      button.appendChild(label);
      return button;
    };

    const isMobileLayout = window.matchMedia("(max-width: 990px)").matches;
    const rowSize = isMobileLayout ? 2 : 3;
    for (let start = 0; start < options.length; start += rowSize) {
      const rowOptions = options.slice(start, start + rowSize);
      const row = document.createElement("div");
      row.className = "lsg-bundle-v2-single-flavor-grid lsg-bundle-v2-single-flavor-grid--row";
      if (rowOptions.length === 1) {
        row.classList.add("is-single-item");
      }
      rowOptions.forEach((option) => row.appendChild(createOptionButton(option)));
      this.v2SingleFlavorPicker.appendChild(row);
    }
  }

  setV2SingleFlavorVariant(variantId = "") {
    if (!this.isV2MobileFlowEnabled()) return;
    const normalizedVariantId = String(variantId || "").trim();
    if (!normalizedVariantId) return;
    this.v2StructureChosen = true;
    this.v2Mode = "single";
    this.v2ActiveSlot = -1;
    this.v2SingleVariantId = normalizedVariantId;
    this.applyV2FlowState();
    this.persistBundleState();
  }

  setV2SlotVariant(slotIndex, variantId) {
    if (!this.isV2MobileFlowEnabled() || !this.v2StructureChosen || this.v2Mode !== "bundle") return;
    if (!Number.isFinite(slotIndex) || slotIndex < 0 || slotIndex > 2) return;
    const normalizedVariantId = String(variantId || "").trim();
    if (!normalizedVariantId) return;

    const firstTwoSelected = Boolean(this.v2BundleSlots[0] && this.v2BundleSlots[1]);
    if (slotIndex === 2 && !firstTwoSelected) return;

    this.v2BundleSlots[slotIndex] = normalizedVariantId;
    this.v2ActiveSlot = -1;
    this.applyV2FlowState();
    this.persistBundleState();
  }

  getNextV2OpenSlotIndex() {
    if (!this.v2BundleSlots[0]) return 0;
    if (!this.v2BundleSlots[1]) return 1;
    if (!this.v2BundleSlots[2]) return 2;
    return 2;
  }

  handleV2FlavorCardSelect(productCard) {
    if (!this.isV2MobileFlowEnabled()) return;
    const variantId = String(productCard?.getAttribute("data-lsg-bundle-v2-variant-select-id") || "").trim();
    if (!variantId) return;
    this.v2StructureChosen = true;

    if (this.v2Mode === "single") {
      this.v2SingleVariantId = variantId;
    } else {
      const firstTwoSelected = Boolean(this.v2BundleSlots[0] && this.v2BundleSlots[1]);
      let targetSlot = this.v2ActiveSlot;
      if (!Number.isFinite(targetSlot) || targetSlot < 0 || targetSlot > 2) {
        targetSlot = this.getNextV2OpenSlotIndex();
      }
      if (targetSlot === 2 && !firstTwoSelected) {
        targetSlot = this.getNextV2OpenSlotIndex();
      }
      this.v2BundleSlots[targetSlot] = variantId;
      this.v2ActiveSlot = -1;
    }

    this.applyV2FlowState();
    this.persistBundleState();
  }

  clearV2SelectionByVariantId(variantId = "") {
    if (!this.isV2MobileFlowEnabled()) return;
    const normalizedVariantId = String(variantId || "").trim();
    if (!normalizedVariantId) return;

    if (this.v2Mode === "single") {
      if (this.v2SingleVariantId === normalizedVariantId) {
        this.v2SingleVariantId = "";
      }
      this.applyV2FlowState();
      this.persistBundleState();
      return;
    }

    const nextSlots = this.v2BundleSlots.map((slotId) => slotId === normalizedVariantId ? "" : slotId);
    this.v2BundleSlots = nextSlots;
    if (!this.v2BundleSlots[0] || !this.v2BundleSlots[1]) {
      this.v2BundleSlots[2] = "";
    }
    this.v2ActiveSlot = this.getNextV2OpenSlotIndex();
    this.applyV2FlowState();
    this.persistBundleState();
  }

  adjustV2Quantity(mode = "single", delta = 0) {
    if (!this.isV2MobileFlowEnabled() || !this.v2StructureChosen) return;
    const quantityDelta = Number(delta);
    if (!Number.isFinite(quantityDelta) || quantityDelta === 0) return;
    const clampQuantity = (value) => Math.max(1, Math.min(99, Number(value) || 1));

    if (mode === "bundle") {
      this.v2BundleQuantity = clampQuantity(this.v2BundleQuantity + quantityDelta);
    } else {
      this.v2SingleQuantity = clampQuantity(this.v2SingleQuantity + quantityDelta);
    }

    this.applyV2FlowState();
    this.persistBundleState();
  }

  getGreatestCommonDivisor(a = 0, b = 0) {
    let left = Math.abs(Number(a) || 0);
    let right = Math.abs(Number(b) || 0);
    while (right > 0) {
      const next = left % right;
      left = right;
      right = next;
    }
    return left || 1;
  }

  getGreatestCommonDivisorForValues(values = []) {
    const normalized = Array.isArray(values)
      ? values.map((value) => Math.abs(Number(value) || 0)).filter((value) => value > 0)
      : [];
    if (!normalized.length) return 1;
    return normalized.reduce((acc, value) => this.getGreatestCommonDivisor(acc, value), normalized[0]);
  }

  applyPersistedV2FlowState(state = {}) {
    if (!state || typeof state !== "object") return false;

    const clampQuantity = (value) => Math.max(1, Math.min(99, Number(value) || 1));
    const modeRaw = String(state.v2Mode || "").trim().toLowerCase();
    if (modeRaw !== "single" && modeRaw !== "bundle") return false;

    this.v2Mode = modeRaw;
    this.v2SingleQuantity = clampQuantity(state.v2SingleQuantity);
    this.v2BundleQuantity = clampQuantity(state.v2BundleQuantity);
    this.v2SingleVariantId = String(state.v2SingleVariantId || "").trim();

    const slotValuesRaw = Array.isArray(state.v2BundleSlots) ? state.v2BundleSlots : [];
    const slotValues = ["", "", ""];
    slotValuesRaw.slice(0, 3).forEach((value, index) => {
      slotValues[index] = String(value || "").trim();
    });
    this.v2BundleSlots = slotValues;

    const activeSlot = Number(state.v2ActiveSlot);
    this.v2ActiveSlot = Number.isFinite(activeSlot) && activeSlot >= -1 && activeSlot <= 2
      ? activeSlot
      : this.getNextV2OpenSlotIndex();
    if (this.v2Mode === "single") {
      this.v2ActiveSlot = -1;
    }
    this.v2PlanWasUnlocked = Boolean(state.v2PlanWasUnlocked);
    this.v2StructureChosen = state.v2StructureChosen !== false;
    this.v2FlowInitialized = true;
    return true;
  }

  hydrateV2FlowStateFromInputs({ preserveCurrentMode = false } = {}) {
    if (!this.isV2MobileFlowEnabled()) return;

    const selectedInputs = Array.from(this.querySelectorAll(".stay-ai-bundle-product-v2__quantity"))
      .map((input) => ({
        input,
        variantId: String(input?.dataset?.product || "").trim(),
        quantity: Number(input?.value || 0),
      }))
      .filter((entry) => entry.variantId && entry.quantity > 0);

    const totalQuantity = selectedInputs.reduce((sum, entry) => sum + entry.quantity, 0);
    const quantities = selectedInputs.map((entry) => entry.quantity);
    const inferredBundleQuantity = this.getGreatestCommonDivisorForValues(quantities);
    const inferredSlots = [];
    selectedInputs.forEach((entry) => {
      const slotCount = Math.max(1, Math.round(entry.quantity / inferredBundleQuantity));
      for (let index = 0; index < slotCount && inferredSlots.length < 3; index += 1) {
        inferredSlots.push(entry.variantId);
      }
    });
    while (inferredSlots.length < 3) {
      inferredSlots.push("");
    }

    if (!selectedInputs.length) {
      if (!preserveCurrentMode) {
        this.v2Mode = "single";
      }
      this.v2SingleQuantity = Math.max(1, Number(this.v2SingleQuantity) || 1);
      this.v2BundleQuantity = Math.max(1, Number(this.v2BundleQuantity) || 1);
      this.v2SingleVariantId = "";
      this.v2BundleSlots = ["", "", ""];
      this.v2ActiveSlot = -1;
      this.v2PlanWasUnlocked = false;
      this.v2StructureChosen = true;
      this.v2FlowInitialized = true;
      return;
    }

    const inferredMode = totalQuantity >= 3 || selectedInputs.length > 1 ? "bundle" : "single";
    const nextMode = preserveCurrentMode
      ? this.v2Mode === "bundle"
        ? "bundle"
        : "single"
      : inferredMode;

    this.v2Mode = nextMode;
    this.v2BundleQuantity = Math.max(1, Number(inferredBundleQuantity) || 1);
    this.v2BundleSlots = inferredSlots.slice(0, 3);
    this.v2SingleVariantId = selectedInputs[0]?.variantId || "";
    this.v2SingleQuantity = Math.max(1, Number(selectedInputs[0]?.quantity) || 1);
    this.v2ActiveSlot = -1;
    this.v2StructureChosen = true;
    this.v2FlowInitialized = true;
  }

  buildV2VariantQuantityMap() {
    const quantityMap = {};

    if (this.v2Mode === "single") {
      if (this.v2SingleVariantId) {
        quantityMap[this.v2SingleVariantId] = this.v2SingleQuantity;
      }
      return quantityMap;
    }

    if (!(this.v2BundleSlots[0] && this.v2BundleSlots[1])) {
      this.v2BundleSlots[2] = "";
    }

    this.v2BundleSlots.forEach((variantId) => {
      if (!variantId) return;
      quantityMap[variantId] = (quantityMap[variantId] || 0) + this.v2BundleQuantity;
    });

    return quantityMap;
  }

  syncV2VariantQuantities(quantityMap = {}) {
    const map = quantityMap && typeof quantityMap === "object" ? quantityMap : {};

    this.querySelectorAll(".stay-ai-bundle-product-v2__quantity").forEach((quantityInput) => {
      const variantId = String(quantityInput.dataset.product || "");
      const maxValue = Number(quantityInput.max);
      const nextQuantityRaw = Number(map[variantId] || 0);
      const clampedQuantity = Number.isFinite(maxValue) && maxValue > 0
        ? Math.max(0, Math.min(maxValue, nextQuantityRaw))
        : Math.max(0, nextQuantityRaw);
      quantityInput.value = String(clampedQuantity);
      this.updateQuantityDisplay(quantityInput);
    });

    this.buildSelectedProductArray();
    this.totalSelectedQtyValidation();
    this.checkoutEnableValidation();
    this.updateBundlePrice();
  }

  ensureV2SubscriptionDefault() {
    const subIntervalInput = this.querySelector(
      '.lsg-bundle-v2-interval-select input[name^="bundle_interval_select_"][value="sub"]');
    if (!subIntervalInput) return;
    if (subIntervalInput.checked) return;

    subIntervalInput.checked = true;
    this.updateInterval(subIntervalInput);
    this.checkoutEnableValidation(subIntervalInput);
  }

  updateV2FlowUi() {
    if (!this.isV2MobileFlowEnabled()) return;

    this.classList.toggle("lsg-bundle-v2-mode-single", this.v2Mode === "single");
    this.classList.toggle("lsg-bundle-v2-mode-bundle", this.v2Mode === "bundle");
    this.classList.toggle("lsg-bundle-v2-structure-chosen", Boolean(this.v2StructureChosen));
    this.classList.toggle("lsg-bundle-v2-structure-pending", !this.v2StructureChosen);

    this.v2StructureButtons?.forEach((button) => {
      const isSelected = this.v2StructureChosen && button.dataset.bundleV2StructureOption === this.v2Mode;
      button.classList.toggle("is-selected", isSelected);
      button.setAttribute("aria-pressed", isSelected ? "true" : "false");
    });

    const firstTwoSelected = Boolean(this.v2BundleSlots[0] && this.v2BundleSlots[1]);
    if (!firstTwoSelected) {
      this.v2BundleSlots[2] = "";
      if (this.v2ActiveSlot === 2) {
        this.v2ActiveSlot = this.getNextV2OpenSlotIndex();
      }
    }

    if (this.v2FlavorStep) {
      this.v2FlavorStep.hidden = !this.v2StructureChosen || this.v2Mode !== "single";
    }

    if (this.v2SlotStep) {
      this.v2SlotStep.hidden = !this.v2StructureChosen || this.v2Mode !== "bundle";
    }

    const slotFallbackLabels = [
      "Click to Select",
      "Click to Select",
      firstTwoSelected ? "Click to Claim Gift" : "Unlock after first 2",
    ];
    if (this.v2SlotOptionContainers?.some((container) => !container.children.length)) {
      this.renderV2SlotOptions();
    }

    this.v2SlotButtons?.forEach((button) => {
      const slotIndex = Number(button.dataset.bundleV2Slot);
      if (!Number.isFinite(slotIndex)) return;
      const slotValue = this.v2BundleSlots[slotIndex] || "";
      const isLockedGift = slotIndex === 2 && !firstTwoSelected;
      const isActiveSlot = this.v2StructureChosen
        && this.v2Mode === "bundle"
        && this.v2ActiveSlot === slotIndex
        && !isLockedGift;
      const valueEl = this.v2SlotValueEls?.find((item) => Number(item.dataset.bundleV2Slot) === slotIndex);
      const clearButton = this.v2SlotClearButtons?.find((item) => Number(item.dataset.bundleV2Slot) === slotIndex);
      const wrapper = this.v2SlotWrappers?.find((item) => Number(item.dataset.bundleV2Slot) === slotIndex);
      const emptyEl = this.v2SlotEmptyEls?.find((item) => Number(item.dataset.bundleV2Slot) === slotIndex);
      const selectedEl = this.v2SlotSelectedEls?.find((item) => Number(item.dataset.bundleV2Slot) === slotIndex);
      const imageEl = this.v2SlotImageEls?.find((item) => Number(item.dataset.bundleV2Slot) === slotIndex);
      const swatchEl = this.v2SlotSwatchEls?.find((item) => Number(item.dataset.bundleV2Slot) === slotIndex);
      const optionContainer = this.v2SlotOptionContainers?.find((item) => Number(item.dataset.bundleV2Slot) === slotIndex);
      const flavorMeta = this.getV2FlavorMetaByVariantId(slotValue);
      const isExpanded = isActiveSlot && !slotValue;
      const shouldShowOptions = isExpanded && !isLockedGift;

      button.disabled = isLockedGift;
      button.classList.toggle("is-filled", Boolean(slotValue));

      if (valueEl) {
        valueEl.textContent = slotValue
          ? flavorMeta?.label || this.getBundleFlavorLabelByVariantId(slotValue) || slotFallbackLabels[slotIndex]
          : slotFallbackLabels[slotIndex];
      }
      if (clearButton) {
        clearButton.hidden = !slotValue;
      }
      if (wrapper) {
        wrapper.classList.toggle("is-active", isActiveSlot);
        wrapper.classList.toggle("is-filled", Boolean(slotValue));
        wrapper.classList.toggle("is-expanded", shouldShowOptions);
        wrapper.classList.toggle("is-locked-gift", isLockedGift);
      }
      if (selectedEl) {
        selectedEl.hidden = !slotValue;
      }
      if (emptyEl) {
        emptyEl.hidden = Boolean(slotValue) || shouldShowOptions;
      }
      if (imageEl) {
        if (slotValue && flavorMeta?.image) {
          imageEl.src = flavorMeta.image;
          imageEl.alt = flavorMeta.imageAlt || flavorMeta.label || "";
        } else {
          imageEl.removeAttribute("src");
          imageEl.alt = "";
        }
      }
      if (swatchEl) {
        swatchEl.style.backgroundColor = slotValue
          ? flavorMeta?.color || "#94a3b8"
          : "transparent";
        swatchEl.hidden = !slotValue;
      }
      if (optionContainer) {
        optionContainer.hidden = !shouldShowOptions;
        optionContainer.querySelectorAll("[data-bundle-v2-slot-option]").forEach((optionButton) => {
          const optionVariant = String(optionButton.dataset.bundleV2Variant || "").trim();
          optionButton.classList.toggle("is-selected", Boolean(slotValue) && optionVariant === slotValue);
        });
      }
    });

    if (this.v2SingleFlavorPicker) {
      if (!this.v2SingleFlavorPicker.children.length) {
        this.renderV2SingleFlavorOptions();
      }
      this.v2SingleFlavorPicker.querySelectorAll("[data-bundle-v2-single-flavor-option]").forEach((optionButton) => {
        const optionVariantId = String(optionButton.dataset.bundleV2Variant || "").trim();
        optionButton.classList.toggle(
          "is-selected",
          this.v2Mode === "single" && Boolean(this.v2SingleVariantId) && optionVariantId === this.v2SingleVariantId);
      });
    }

    if (this.v2SlotCounter) {
      const selectedPaidCount = [this.v2BundleSlots[0], this.v2BundleSlots[1]].filter(Boolean).length;
      this.v2SlotCounter.textContent = selectedPaidCount >= 2
        ? "✓ Ready to checkout!"
        : `${selectedPaidCount}/2 required (+ 1 free)`;
    }
    if (this.v2SlotProgressFill) {
      const selectedPaidCount = [this.v2BundleSlots[0], this.v2BundleSlots[1]].filter(Boolean).length;
      const widthPercent = Math.min(100, (selectedPaidCount / 2) * 100);
      this.v2SlotProgressFill.style.width = `${widthPercent}%`;
    }

    if (this.v2SingleQtyWrap) this.v2SingleQtyWrap.hidden = this.v2Mode !== "single";
    if (this.v2BundleQtyWrap) this.v2BundleQtyWrap.hidden = true;
    if (this.v2SingleQtyValueEl) this.v2SingleQtyValueEl.textContent = String(this.v2SingleQuantity);
    if (this.v2BundleQtyValueEl) this.v2BundleQtyValueEl.textContent = String(this.v2BundleQuantity);

    const hasSingleFlavor = Boolean(this.v2SingleVariantId);
    const hasBundleRequiredFlavors = Boolean(this.v2BundleSlots[0] && this.v2BundleSlots[1]);
    const isUnlocked = this.v2StructureChosen
      && (this.v2Mode === "single" ? hasSingleFlavor : hasBundleRequiredFlavors);

    if (this.v2PlanStep) this.v2PlanStep.hidden = !isUnlocked;
    if (this.v2AddStep) this.v2AddStep.hidden = !isUnlocked;
    this.classList.toggle("lsg-bundle-v2-flow-unlocked", isUnlocked);
    this.classList.toggle("lsg-bundle-v2-flow-locked", !isUnlocked);

    if (isUnlocked && !this.v2PlanWasUnlocked) {
      this.ensureV2SubscriptionDefault();
    }
    this.v2PlanWasUnlocked = isUnlocked;
  }

  applyV2FlowState() {
    if (!this.isV2MobileFlowEnabled()) return;
    const quantityMap = this.buildV2VariantQuantityMap();
    this.syncV2VariantQuantities(quantityMap);
    this.updateV2FlowUi();
  }

  getBundleTextConfig() {
    const rawConfig = this.dataset?.bundleTexts;
    if (!rawConfig) return {};
    try {
      const parsedConfig = JSON.parse(rawConfig);
      return parsedConfig && typeof parsedConfig === "object" ? parsedConfig : {};
    } catch (error) {
      return {};
    }
  }

  formatBundleText(template = "", replacements = {}) {
    if (!template || typeof template !== "string") return "";
    if (!replacements || typeof replacements !== "object") return template;
    return Object.entries(replacements).reduce((result, [key, value]) => {
      const replaceValue = value === null || value === undefined ? "" : String(value);
      return result
        .replaceAll(`{${key}}`, replaceValue)
        .replaceAll(`__${key}__`, replaceValue);
    }, template);
  }

  getBundleText(key, fallbackValue = "", replacements = null) {
    const sourceValue = this.bundleTextConfig && Object.prototype.hasOwnProperty.call(this.bundleTextConfig, key)
      ? this.bundleTextConfig[key]
      : fallbackValue;
    const normalizedValue = sourceValue === null || sourceValue === undefined
      ? ""
      : String(sourceValue);
    if (!replacements) return normalizedValue;
    return this.formatBundleText(normalizedValue, replacements);
  }

  sortFrequencySelects() {
    const selects = this.querySelectorAll('.lsg-bundle-v2-interval-frequency-select');
    const parseIntervalDays = (label = "") => {
      const match = String(label).match(/(\d+)\s*(day|week|month|year)s?/i);
      if (!match) return Number.POSITIVE_INFINITY;
      const count = Number(match[1]) || 0;
      const unit = match[2].toLowerCase();
      const multiplier = unit.startsWith('day')
        ? 1
        : unit.startsWith('week')
        ? 7
        : unit.startsWith('month')
        ? 30
        : unit.startsWith('year')
        ? 365
        : 1;
      return count * multiplier;
    };

    selects.forEach((select) => {
      const options = Array.from(select.options);
      const selectedValue = select.value;
      options.sort((a, b) => parseIntervalDays(a.textContent) - parseIntervalDays(b.textContent));
      select.innerHTML = "";
      options.forEach((option) => select.appendChild(option));
      if (selectedValue) {
        select.value = selectedValue;
      }
    });
  }

  hasBundleParamsInUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const keyGroups = [BUNDLE_V2_URL_KEYS];
    if (this.shouldUseLegacyCompatibility()) {
      keyGroups.push(BUNDLE_V2_LEGACY_URL_KEYS);
    }
    return keyGroups.some((keys) => (
      urlParams.has(keys.items) ||
      urlParams.has(keys.index) ||
      urlParams.has(keys.interval) ||
      urlParams.has(keys.frequency)
    ));
  }

  shouldUseLegacyCompatibility() {
    const hasV1Wrapper = Boolean(document.querySelector(".lsg-bundle-wrapper"));
    const hasV2Wrapper = Boolean(document.querySelector(".lsg-bundle-v2-wrapper"));
    return !(hasV1Wrapper && hasV2Wrapper);
  }

  getBundleStateStorageKey(prefix = BUNDLE_V2_STORAGE_PREFIX) {
    const bundleHandle = this.dataset.bundleHandle || "";
    const bundleKey = bundleHandle || `bundle-${this.bundleIndex || "0"}`;
    return `${prefix}:${window.location.pathname}:${bundleKey}`;
  }

  getLegacyBundleStateStorageKey() {
    return this.getBundleStateStorageKey(BUNDLE_V2_LEGACY_STORAGE_PREFIX);
  }

  readPersistedBundleState() {
    try {
      const storage = window.sessionStorage;
      if (!storage) return null;
      const nextKey = this.getBundleStateStorageKey();
      const legacyKey = this.getLegacyBundleStateStorageKey();
      const parseState = (rawState = "") => {
        if (!rawState) return null;
        const parsedState = JSON.parse(rawState);
        return parsedState && typeof parsedState === "object" ? parsedState : null;
      };

      const nextState = parseState(storage.getItem(nextKey));
      if (nextState) return nextState;

      if (!this.shouldUseLegacyCompatibility()) return null;

      const legacyState = parseState(storage.getItem(legacyKey));
      if (!legacyState) return null;

      storage.setItem(nextKey, JSON.stringify(legacyState));
      storage.removeItem(legacyKey);
      return legacyState;
    } catch (error) {
      return null;
    }
  }

  clearPersistedBundleState() {
    try {
      const storage = window.sessionStorage;
      if (!storage) return;
      storage.removeItem(this.getBundleStateStorageKey());
      if (this.shouldUseLegacyCompatibility()) {
        storage.removeItem(this.getLegacyBundleStateStorageKey());
      }
    } catch (error) {
      // ignore storage failures
    }
  }

  persistBundleState({ source = "builder", cartBundleId = "" } = {}) {
    if (this.isRestoringPersistedState) return;
    try {
      const storage = window.sessionStorage;
      if (!storage) return;

      const items = {};
      this.querySelectorAll(".stay-ai-bundle-product-v2__quantity").forEach((input) => {
        const productId = String(input.dataset.product || "");
        const qty = Number(input.value) || 0;
        if (!productId || qty <= 0) return;
        items[productId] = qty;
      });

      const intervalInput = this.querySelector(
        '.lsg-bundle-v2-interval-select input[name^="bundle_interval_select_"]:checked');
      const frequencySelect = this.querySelector(".lsg-bundle-v2-interval-frequency-select");

      storage.setItem(
        this.getBundleStateStorageKey(),
        JSON.stringify({
          items,
          interval: intervalInput?.value || "",
          frequency: frequencySelect?.value || "",
          v2Mode: this.v2Mode === "bundle" ? "bundle" : "single",
          v2SingleQuantity: Math.max(1, Number(this.v2SingleQuantity) || 1),
          v2BundleQuantity: Math.max(1, Number(this.v2BundleQuantity) || 1),
          v2SingleVariantId: String(this.v2SingleVariantId || ""),
          v2BundleSlots: Array.isArray(this.v2BundleSlots)
            ? this.v2BundleSlots.slice(0, 3).map((value) => String(value || ""))
            : ["", "", ""],
          v2ActiveSlot: Number.isFinite(Number(this.v2ActiveSlot))
            ? Math.max(-1, Math.min(2, Number(this.v2ActiveSlot)))
            : -1,
          v2PlanWasUnlocked: Boolean(this.v2PlanWasUnlocked),
          v2StructureChosen: Boolean(this.v2StructureChosen),
          isActiveBundle: this.classList.contains("lsg-bundle-v2-block-active"),
          source: String(source || "builder"),
          cartBundleId: String(cartBundleId || ""),
          savedAt: Date.now(),
        }));
    } catch (error) {
      // ignore storage failures
    }
  }

  restoreBundleState() {
    const state = this.readPersistedBundleState();
    const source = String(state?.source || "").trim().toLowerCase();
    if (source === "cart") {
      this.clearPersistedBundleState();
      return false;
    }
    return this.applyBundleState(state);
  }

  applyBundleState(
    state,
    { persistAfterApply = false, persistSource = "builder", cartBundleId = "" } = {}) {
    if (!state || typeof state !== "object") return false;
    const hasPersistedV2FlowState = this.applyPersistedV2FlowState(state);

    this.isRestoringPersistedState = true;
    try {
      const interval = String(state.interval || "");
      if (interval) {
        const intervalInput = this.querySelector(
          `.lsg-bundle-v2-interval-select input[name^="bundle_interval_select_"][value="${interval}"]`);
        if (intervalInput) {
          intervalInput.checked = true;
          this.updateInterval(intervalInput);
        }
      }

      const frequencySelect = this.querySelector(".lsg-bundle-v2-interval-frequency-select");
      const frequency = String(state.frequency || "");
      if (
        frequencySelect &&
        frequency &&
        Array.from(frequencySelect.options || []).some((option) => option.value === frequency)
      ) {
        frequencySelect.value = frequency;
        this.updateFrequency(frequencySelect);
      }

      this.querySelectorAll(".stay-ai-bundle-product-v2__quantity").forEach((input) => {
        input.value = 0;
        this.updateQuantityDisplay(input);
      });

      const items = state.items && typeof state.items === "object" ? state.items : {};
      Object.entries(items).forEach(([productId, qty]) => {
        const quantity = Number(qty) || 0;
        if (quantity <= 0) return;
        const quantityInput = this.querySelector(
          `.stay-ai-bundle-product-v2__quantity[data-product="${productId}"]`);
        this.updateQuantityInput(quantityInput, quantity);
      });

      if (this.isV2MobileFlowEnabled() && !hasPersistedV2FlowState) {
        this.hydrateV2FlowStateFromInputs();
      }

      this.updateSelectedProductGUI();
      this.totalSelectedQtyValidation();
      this.checkoutEnableValidation();
      this.updateBundlePrice();
      this.updateFlavorSelectionHelper();
      this.updateStickySummary();
      if (this.isV2MobileFlowEnabled()) {
        this.updateV2FlowUi();
      }
      this.requestStickyOfferBarUpdate({
        otpSubtotal: this.lastOtpSubtotal,
        subSubtotal: this.lastSubSubtotal,
        compareSubtotal: this.lastCompareSubtotal,
      });
    } finally {
      this.isRestoringPersistedState = false;
    }

    if (persistAfterApply) {
      this.persistBundleState({
        source: persistSource,
        cartBundleId,
      });
    }

    return true;
  }

  getBundleMatchingHandles() {
    const bundleHandle = (this.dataset.bundleHandle || "").toLowerCase();
    const handleMap = window.bundleUpgradeHandleMap || {};
    const matchingHandles = [];
    if (bundleHandle) {
      matchingHandles.push(bundleHandle);
      let nextHandle = handleMap[bundleHandle];
      while (nextHandle && !matchingHandles.includes(nextHandle)) {
        matchingHandles.push(nextHandle);
        nextHandle = handleMap[nextHandle];
      }
    }
    return matchingHandles;
  }

  getBundleParentItemFromCart(cart) {
    if (!Array.isArray(cart?.items)) return null;
    const bundleVariantId = this.getBundleParentVariantId();
    const matchingHandles = this.getBundleMatchingHandles();
    return cart.items.find((item) => {
      const isBundleParent = item?.properties && item.properties._bundle_parent;
      if (!isBundleParent) return false;
      const itemId = String(item.id || item.variant_id || "");
      const itemHandle = String(item.handle || item.product_handle || "").toLowerCase();
      const matchesHandle =
        matchingHandles.length > 0 && matchingHandles.includes(itemHandle);
      return (bundleVariantId && itemId === bundleVariantId) || matchesHandle;
    }) || null;
  }

  getBundleSelectableVariantIds() {
    const variantIds = new Set();
    this.querySelectorAll(".stay-ai-bundle-product-v2__quantity").forEach((input) => {
      const variantId = String(input?.dataset?.product || "");
      if (!variantId) return;
      variantIds.add(variantId);
    });
    return variantIds;
  }

  getFallbackBundleStateFromCart(cart) {
    // Deprecated in isolation mode: builder state no longer rehydrates from cart.
    return null;
  }

  getCartLineKeysForBundleReplacement(cart) {
    // Deprecated in isolation mode: no pre-clear/replace by cart lines.
    return [];
  }

  clearMatchingBundleLinesFromCart({ forceRefresh = true } = {}) {
    // Deprecated in isolation mode: bundle add is non-destructive.
    return this.getCartSnapshot({ forceRefresh });
  }

  getCartSnapshot({ forceRefresh = false } = {}) {
    const now = Date.now();
    const cacheTtlMs = 1200;
    const snapshotKey = BUNDLE_V2_CART_SNAPSHOT_KEYS.snapshot;
    const snapshotAtKey = BUNDLE_V2_CART_SNAPSHOT_KEYS.snapshotAt;
    const snapshotPromiseKey = BUNDLE_V2_CART_SNAPSHOT_KEYS.snapshotPromise;
    const hasFreshCache =
      !forceRefresh &&
      now - (window[snapshotAtKey] || 0) < cacheTtlMs &&
      window[snapshotKey] !== undefined;
    if (hasFreshCache) {
      return Promise.resolve(window[snapshotKey]);
    }

    if (!forceRefresh && window[snapshotPromiseKey]) {
      return window[snapshotPromiseKey];
    }

    const rootPath =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      "/";
    const cartUrl = `${rootPath}cart.js`;

    const request = fetch(cartUrl, { credentials: "same-origin" })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Cart fetch failed (${response.status})`);
        }
        return response.json();
      })
      .then((cart) => {
        window[snapshotKey] = cart;
        window[snapshotAtKey] = Date.now();
        return cart;
      })
      .catch(() => {
        window[snapshotKey] = null;
        window[snapshotAtKey] = Date.now();
        return null;
      })
      .finally(() => {
        if (window[snapshotPromiseKey] === request) {
          window[snapshotPromiseKey] = null;
        }
      });

    window[snapshotPromiseKey] = request;
    return request;
  }

  invalidateCartSnapshotCache() {
    window[BUNDLE_V2_CART_SNAPSHOT_KEYS.snapshot] = undefined;
    window[BUNDLE_V2_CART_SNAPSHOT_KEYS.snapshotAt] = 0;
    window[BUNDLE_V2_CART_SNAPSHOT_KEYS.snapshotPromise] = null;
  }

  handleExternalCartChange() {
    // Deprecated in isolation mode: builder state is not coupled to cart updates.
    this.invalidateCartSnapshotCache();
    this.checkStickyAtcVisibility({ forceRefresh: true });
  }

  getBundleStateFromCart(cart, bundleParentItem = null) {
    // Deprecated in isolation mode: builder state no longer rehydrates from cart.
    void cart;
    void bundleParentItem;
    return null;
  }

  syncBundleStateFromCart({ forceRefresh = false } = {}) {
    // Deprecated in isolation mode: builder state no longer syncs from cart.
    void forceRefresh;
    return Promise.resolve(false);
  }

  loadEventListeners() {
    //Event Listeners
    this.querySelectorAll('[data-bundle-builder-selected-product-remove-button]').forEach((removeButton) => {
      removeButton.addEventListener('click', this.removeButtonEvent.bind(this));
    });
    
    this.querySelectorAll('.stay-ai-bundle-product-v2__quantity-selector').forEach((quantitySelector) => {
      quantitySelector.addEventListener("click", this.toggleQuantityEvent.bind(this));
    });
    this.querySelectorAll('.lsg-bundle-v2-flavors-grid .lsg-bundle-v2-product-select-wrapper').forEach((productCard) => {
      productCard.addEventListener('click', (event) => {
        if (
          event.target.closest('.lsg-bundle-v2-product-select-quantity-wrap') ||
          event.target.closest('[data-bundle-product-info-open]')
        ) return;
        this.setShowcaseCard(productCard, 0, { preserveSlide: false });
      });
    });
    if (this.showcaseRoot) {
      if (!this.showcaseRoot.hasAttribute("tabindex")) {
        this.showcaseRoot.setAttribute("tabindex", "0");
      }
      this.showcaseRoot.addEventListener("keydown", this.boundShowcaseKeydown);
      const zoomOpenTrigger = this.showcaseRoot.querySelector('[data-bundle-showcase-zoom-open]');
      if (zoomOpenTrigger) {
        zoomOpenTrigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.openShowcaseZoom();
        });
      }

      if (this.showcaseZoom) {
        this.showcaseZoom.querySelectorAll('[data-bundle-showcase-zoom-close]').forEach((closeButton) => {
          closeButton.addEventListener('click', (event) => {
            event.preventDefault();
            this.closeShowcaseZoom();
          });
        });

        if (this.showcaseZoomToggle) {
          this.showcaseZoomToggle.addEventListener('click', (event) => {
            event.preventDefault();
            this.toggleShowcaseZoomScale();
          });
        }

        if (this.showcaseZoomImage) {
          this.showcaseZoomImage.addEventListener('click', () => {
            this.toggleShowcaseZoomScale();
          });
        }
      }

      if (this.showcaseFlavors) {
        this.showcaseFlavors.addEventListener('click', (event) => {
          const flavorButton = event.target.closest('[data-bundle-showcase-flavor]');
          if (!flavorButton) return;
          const variantId = flavorButton.getAttribute('data-bundle-showcase-flavor');
          if (!variantId) return;
          const targetCard = this.querySelector(`.lsg-bundle-v2-product-select-wrapper[data-lsg-bundle-v2-variant-select-id="${variantId}"]`);
          if (!targetCard) return;
          this.setShowcaseCard(targetCard, 0, { preserveSlide: false });
        });
      }

      const onShowcaseSlideClick = (event) => {
        const slideButton = event.target.closest('[data-bundle-showcase-slide]');
        if (!slideButton) return;
        const nextIndex = Number(slideButton.getAttribute('data-bundle-showcase-slide'));
        if (Number.isNaN(nextIndex)) return;
        this.setShowcaseSlide(nextIndex);
      };

      if (this.showcaseThumbs) {
        this.showcaseThumbs.addEventListener('click', onShowcaseSlideClick);
      }
      if (this.showcaseDots) {
        this.showcaseDots.addEventListener('click', onShowcaseSlideClick);
      }
      if (this.showcasePrevButton) {
        this.showcasePrevButton.addEventListener('click', (event) => {
          event.preventDefault();
          this.setShowcaseSlide(this.showcaseSlideIndex - 1);
        });
      }
      if (this.showcaseNextButton) {
        this.showcaseNextButton.addEventListener('click', (event) => {
          event.preventDefault();
          this.setShowcaseSlide(this.showcaseSlideIndex + 1);
        });
      }
    }
    this.querySelectorAll('[data-bundle-product-info-open]').forEach((infoButton) => {
      infoButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.openProductModal(infoButton);
      });
    });
    if (this.productModal) {
      this.productModal.querySelectorAll('[data-bundle-product-modal-close]').forEach((closeButton) => {
        closeButton.addEventListener('click', (event) => {
          event.preventDefault();
          this.closeProductModal();
        });
      });
      if (this.productModalAddButton) {
        this.productModalAddButton.addEventListener('click', (event) => {
          event.preventDefault();
          this.addModalProductToBundle();
        });
      }
      if (this.productModalDots) {
        this.productModalDots.addEventListener('click', (event) => {
          const dotButton = event.target.closest('[data-bundle-product-modal-dot]');
          if (!dotButton) return;
          const nextIndex = Number(dotButton.dataset.bundleProductModalDot);
          if (Number.isNaN(nextIndex)) return;
          this.setProductModalSlide(nextIndex);
        });
      }
    }
    if (this.stickyViewToggle && this.stickyViewPanel) {
      this.stickyViewToggle.addEventListener("click", (event) => {
        event.preventDefault();
        this.updateSelectedProductGUI();
        const isExpanded = this.stickyViewToggle.getAttribute("aria-expanded") === "true";
        this.stickyViewToggle.setAttribute("aria-expanded", isExpanded ? "false" : "true");
        this.stickyViewPanel.hidden = isExpanded;
        if (this.stickyBar) {
          this.stickyBar.classList.toggle("is-expanded", !isExpanded);
        }
      });
    }
    this.querySelectorAll('.stay-ai-bundle-product-v2__quantity').forEach(function(input){
      input.addEventListener('change', function(e){
          this.inputChangeSubProduct(e.currentTarget);
          this.totalSelectedQtyValidation(e.currentTarget);
          this.checkoutEnableValidation(e.currentTarget);
      })
    });
    this.querySelectorAll('.lsg-bundle-v2-interval-select input[name^="bundle_interval_select_"]').forEach(function(intervalSelector){
      intervalSelector.addEventListener('change', (e) => {
        this.updateInterval(e.currentTarget);
        this.checkoutEnableValidation(e.currentTarget);
        this.setUrl(e.currentTarget);
      });
    }.bind(this));
    this.querySelectorAll('.lsg-bundle-v2-interval-frequency-select').forEach(function(frequencySelect){
      frequencySelect.addEventListener('change', (e) => {
        this.updateFrequency(e.currentTarget);
        this.setUrl(e.currentTarget);
      })
    }.bind(this));
    this.querySelectorAll('[data-bundle-unlock-perks]').forEach((unlockButton) => {
      unlockButton.addEventListener('click', this.handleUnlockPerks.bind(this));
    });
    this.querySelectorAll('[data-bundle-atc]').forEach(function (bundleATC) {
      bundleATC.addEventListener('click', (e) => {
        e.preventDefault();
        if(!this.hasRequiredProductQuantity) {
          this.showRequiredMessage();
        } else {
          this.addToCart(e.currentTarget);
        }
      })
    }.bind(this));
    this.querySelectorAll('.lsg-bundle-v2-size-select-el').forEach(function(bundleSelector) {
      bundleSelector.addEventListener('click', (e) => {
        e.preventDefault();
        this.setActiveBundle(e.currentTarget);
      })
    }.bind(this));

    window.addEventListener("scroll", this.boundStickyViewportUpdate, { passive: true });
    window.addEventListener("resize", this.boundStickyViewportUpdate);
    window.addEventListener("resize", this.boundHintLabelUpdate);
  }

  /**
   * Removes selected product
   * @param {EventListener} event - Remove icon event
   */
  removeButtonEvent(event) {
    event.preventDefault();

    const triggeredProductWrapper = event.target.closest("[data-bundle-builder-selected-variant-id]");
    if (!triggeredProductWrapper) return;
    this.productSelectionButtonClicked = true;
    this.productSelectionIndex = triggeredProductWrapper.getAttribute("data-index");

    const variantID = triggeredProductWrapper.getAttribute("data-bundle-builder-selected-variant-id");
    if (!variantID) return;
    const bundleProduct = this.querySelector(`[data-lsg-bundle-v2-variant-select-id='${variantID}']`);
    if (!bundleProduct) return;
    const bundleProductDecrement = bundleProduct.querySelector(".lsg-bundle-v2-product-select-quantity-minus");
    if (!bundleProductDecrement) return;
    bundleProductDecrement.click();
  }

    /**
   * Toggles quantity selector on selected product
   * @param {EventListener} event - Quantity plus minus icon event
   */
    toggleQuantityEvent(event) {
      event.preventDefault();
      const currentTarget = event.currentTarget;
      this.toggleProductQuantity(currentTarget);
      this.buildSelectedProductArray(currentTarget);
      this.totalSelectedQtyValidation(currentTarget);
      this.checkoutEnableValidation();
      this.setUrl(currentTarget);
      this.persistBundleState();
    }

  /**
   * Validates selected quantity total on product selection
   * @param {HTMLElement} trigger - Selected quantity
  */
  inputChangeSubProduct(trigger) {
    if(isNaN(trigger.value) || trigger.value == "" || trigger.value < 0){
      trigger.value = 0;
    }

    if(trigger.value > parseInt(trigger.max)) {
      trigger.value = parseInt(trigger.max);
    }

    if(trigger.value < parseInt(trigger.min)) {
      trigger.value = parseInt(trigger.min);
    }

    const bundleMax = trigger.closest('.stay-ai-bundle-product-v2__cards').dataset.bundleMax;
    const bundleQuantity = this.getSelectedChildProductQty(trigger);

    if((bundleQuantity > bundleMax) && bundleMax > 0) {
      let bundleDif = bundleQuantity - bundleMax;
      if(trigger.value >= bundleDif) {
        //reduce quantity to stay within bundle max
        trigger.value = (trigger.value - bundleDif);
      } else {
        //something went wrong, reset all values to min
        this.querySelectorAll('.stay-ai-bundle-product-v2__quantity').forEach((input) => {
          input.value = parseInt(input.min);
        });
      }
    }
    this.updateQuantityDisplay(trigger);
    this.updateBundlePrice(trigger);
  }

  /**
   * Toggle product quantity and update display based on selector type
   * @param {EventListener} target - Product add click event listener
   */
  toggleProductQuantity(target) {
    const selectorType = target.classList.contains("lsg-bundle-v2-product-select-quantity-minus") ? "minus" : "plus";
    let selectedQuantity = target.closest(".lsg-bundle-v2-product-select-quantity-wrap").querySelector(".stay-ai-bundle-product-v2__quantity");
    const bundleQuantity = this.getSelectedChildProductQty(target);

    switch(selectorType) {
      case "plus":
        if (Number(this.bundleMax) > 0 && bundleQuantity >= Number(this.bundleMax)) return;
        selectedQuantity.value = selectedQuantity.value >= parseInt(selectedQuantity.max)
          ? Number(selectedQuantity.max)
          : Number(selectedQuantity.value) + 1;
        break;
      case "minus":
        selectedQuantity.value = selectedQuantity.value <= parseInt(selectedQuantity.min)
          ? 0
          : Number(selectedQuantity.value) - 1;
        break;
    }
    this.updateBundlePrice()
    this.updateQuantityDisplay(selectedQuantity);
    this.mirrorQuantityDisplay(selectedQuantity);
    const changedCard = target.closest('.lsg-bundle-v2-product-select-wrapper');
    if (selectorType === "plus" && changedCard) {
      this.setShowcaseCard(changedCard, 0, { preserveSlide: false });
    }
    this.syncShowcaseWithSelection(changedCard);
  }

  /**
   * Updates options on selected products
   * @param {HTMLElement} input - Selected quantity input
   */
  mirrorQuantityDisplay(input) {
    const productID = input.dataset.product;
    const productInputs = this.querySelectorAll('[data-product="' + productID + '"].stay-ai-bundle-product-v2__quantity');
    
    productInputs.forEach((productInput) => {
      if (productInput === input || !this) return;

      this.inputChangeSubProduct(productInput);
    });
  }

  /**
   * Updates selected quantity total on individual child products
   * @param {HTMLElement} qtySelector - Selected quantity selector
   */
  updateQuantityDisplay(qtySelector) {
      const inputWrap = qtySelector.closest('.lsg-bundle-v2-product-select-quantity-wrap');
      const inputDisplay = qtySelector.parentNode.querySelector('.stay-ai-bundle-product-v2__quantity-display');
      const quantity = Number(qtySelector.value) || 0;
      const card = qtySelector.closest('.lsg-bundle-v2-product-select-wrapper');
      
      inputWrap.classList.toggle("no-quantity", quantity <= 0);
      
      if(inputDisplay) {
        inputDisplay.innerHTML = String(quantity);
      }

      if (card) {
        card.classList.toggle("is-selected", quantity > 0);
        const quantityBadge = card.querySelector("[data-bundle-quantity-badge]");
        if (quantityBadge) {
          quantityBadge.textContent = String(quantity);
          quantityBadge.hidden = quantity <= 0;
        }
      }
  }

  openProductModal(trigger) {
    if (!this.productModal) return;
    const card = trigger.closest('.lsg-bundle-v2-product-select-wrapper');
    if (!card) return;

    this.modalActiveCard = card;
    this.populateProductModal(card);
    this.productModal.hidden = false;
    this.productModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lsg-bundle-v2-modal-open');
    document.addEventListener('keydown', this.boundModalKeydown);
  }

  closeProductModal() {
    if (!this.productModal || this.productModal.hidden) return;
    this.productModal.hidden = true;
    this.productModal.setAttribute('aria-hidden', 'true');
    this.modalActiveCard = null;
    document.body.classList.remove('lsg-bundle-v2-modal-open');
    document.removeEventListener('keydown', this.boundModalKeydown);
  }

  addModalProductToBundle() {
    if (!this.modalActiveCard) {
      this.closeProductModal();
      return;
    }
    const plusButton = this.modalActiveCard.querySelector('.lsg-bundle-v2-product-select-quantity-plus');
    if (plusButton && !plusButton.disabled) {
      plusButton.click();
    }
    this.closeProductModal();
  }

  handleModalKeydown(event) {
    if (!this.productModal || this.productModal.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      this.closeProductModal();
      return;
    }
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.setProductModalSlide(this.modalGalleryIndex + 1);
      return;
    }
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      this.setProductModalSlide(this.modalGalleryIndex - 1);
    }
  }

  handleShowcaseKeydown(event) {
    if (!this.showcaseRoot || !this.showcaseSlides.length) return;
    if (!this.showcaseRoot.contains(event.target)) return;

    const target = event.target;
    const tagName = target?.tagName ? target.tagName.toLowerCase() : "";
    if (tagName === "input" || tagName === "select" || tagName === "textarea" || target?.isContentEditable) {
      return;
    }

    if (event.key === "ArrowRight") {
      event.preventDefault();
      this.setShowcaseSlide(this.showcaseSlideIndex + 1);
      return;
    }

    if (event.key === "ArrowLeft") {
      event.preventDefault();
      this.setShowcaseSlide(this.showcaseSlideIndex - 1);
    }
  }

  populateProductModal(card) {
    if (!this.productModalTrack) return;

    const title = card.dataset.bundleCardTitle || card.querySelector('.lsg-bundle-v2-product-select-title')?.textContent?.trim() || '';
    const description = card.dataset.bundleCardDescription || '';
    const calories = card.dataset.bundleCardCalories || '';

    if (this.productModalTitle) {
      this.productModalTitle.textContent = title;
    }
    if (this.productModalDescription) {
      this.productModalDescription.textContent = description;
    }
    if (this.productModalCalories) {
      this.productModalCalories.textContent = calories;
      this.productModalCalories.hidden = calories === '';
    }

    this.productModalTrack.innerHTML = '';
    const modalSource = card.querySelectorAll('[data-bundle-product-modal-source] img');
    const sourceImages = modalSource.length
      ? Array.from(modalSource)
      : [card.querySelector('.lsg-bundle-v2-product-select-img-wrap img')].filter(Boolean);

    sourceImages.forEach((sourceImage, index) => {
      const slide = document.createElement('div');
      const clonedImage = sourceImage.cloneNode(true);
      slide.className = 'lsg-bundle-v2-product-modal__slide swiper-slide';
      clonedImage.loading = index === 0 ? 'eager' : 'lazy';
      slide.appendChild(clonedImage);
      this.productModalTrack.appendChild(slide);
    });

    this.productModalGalleryLength = sourceImages.length;
    this.renderProductModalDots(this.productModalGalleryLength);
    this.initProductModalSwiper();
    this.setProductModalSlide(0, { animate: false });
  }

  renderProductModalDots(slideCount) {
    if (!this.productModalDots) return;
    this.productModalDots.innerHTML = '';
    this.productModalDots.hidden = slideCount <= 1;
    if (slideCount <= 1) return;

    for (let i = 0; i < slideCount; i++) {
      const dotButton = document.createElement('button');
      dotButton.type = 'button';
      dotButton.className = 'lsg-bundle-v2-product-modal__dot';
      dotButton.dataset.bundleProductModalDot = String(i);
      dotButton.setAttribute(
        'aria-label',
        this.getBundleText("showcaseViewImageAriaTemplate", "View image {index}", { index: i + 1 }));
      this.productModalDots.appendChild(dotButton);
    }
  }

  updateProductModalDotsState(activeIndex = this.modalGalleryIndex) {
    if (!this.productModalDots) return;
    this.productModalDots.querySelectorAll('[data-bundle-product-modal-dot]').forEach((dot, index) => {
      const isActive = index === activeIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  initProductModalSwiper() {
    this.destroyProductModalSwiper();
    if (!this.productModalGallery || !this.productModalTrack || this.productModalGalleryLength <= 0) return;
    const canSwipe = this.productModalGalleryLength > 1;
    this.productModalSwiper = new Swiper(this.productModalGallery, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 360,
      allowTouchMove: canSwipe,
      simulateTouch: canSwipe,
      threshold: 8,
      resistanceRatio: 0.8,
      nested: true,
      on: {
        slideChange: () => {
          this.modalGalleryIndex = this.productModalSwiper?.activeIndex || 0;
          this.updateProductModalDotsState(this.modalGalleryIndex);
        },
      },
    });
  }

  destroyProductModalSwiper() {
    if (!this.productModalSwiper) return;
    this.productModalSwiper.destroy(true, true);
    this.productModalSwiper = null;
  }

  setProductModalSlide(nextIndex, options = {}) {
    if (!this.productModalTrack || this.productModalGalleryLength <= 0) return;
    const lastIndex = this.productModalGalleryLength - 1;
    const clampedIndex = Math.max(0, Math.min(lastIndex, nextIndex));
    this.modalGalleryIndex = clampedIndex;
    if (this.productModalSwiper && this.productModalSwiper.activeIndex !== clampedIndex) {
      const speed = options.animate === false ? 0 : 360;
      this.productModalSwiper.slideTo(clampedIndex, speed, false);
    }
    this.updateProductModalDotsState(clampedIndex);
  }

  getShowcaseCards() {
    return Array.from(this.querySelectorAll('.lsg-bundle-v2-product-select-wrapper'));
  }

  getShowcaseSlidesForCard(card) {
    if (!card) return [];

    const modalImages = Array.from(card.querySelectorAll('[data-bundle-product-modal-source] img'));
    const sourceImages = modalImages.length
      ? modalImages
      : [card.querySelector('.lsg-bundle-v2-product-select-img-wrap img')].filter(Boolean);

    return sourceImages
      .map((image, index) => ({
        src: image.currentSrc || image.src || "",
        alt: image.alt || card.dataset.bundleCardTitle || this.getBundleText(
          "showcaseProductViewAltTemplate",
          "Product view {index}",
          { index: index + 1 }),
      }))
      .filter((slide) => Boolean(slide.src))
      .slice(0, 9);
  }

  getShowcaseImageByIndex(index = 0) {
    if (!this.showcaseTrack) return null;
    const images = this.showcaseTrack.querySelectorAll('.lsg-bundle-v2-showcase__main-image');
    return images[index] || null;
  }

  getActiveShowcaseImageElement() {
    if (this.showcaseSwiper?.slides?.length) {
      const activeSlide = this.showcaseSwiper.slides[this.showcaseSwiper.activeIndex];
      return activeSlide?.querySelector('.lsg-bundle-v2-showcase__main-image') || null;
    }
    return this.getShowcaseImageByIndex(this.showcaseSlideIndex);
  }

  initializeShowcase() {
    if (!this.showcaseRoot || !this.showcaseTrack) return;

    const cards = this.getShowcaseCards();
    if (!cards.length) return;

    this.renderShowcaseFlavorButtons(cards);
    this.syncShowcaseWithSelection();
  }

  renderShowcaseFlavorButtons(cards = this.getShowcaseCards()) {
    if (!this.showcaseFlavors) return;
    this.showcaseFlavors.innerHTML = "";

    cards.forEach((card) => {
      const flavorName =
        card.dataset.bundleCardTitle
        || card.querySelector('.lsg-bundle-v2-product-select-title')?.textContent?.trim()
        || this.getBundleText("fallbackFlavorLabelText", "Flavor");
      const flavorHex = card.dataset.bundleFlavorHex || "#94a3b8";
      const variantId = card.getAttribute('data-lsg-bundle-v2-variant-select-id') || "";
      if (!variantId) return;

      const flavorButton = document.createElement('button');
      flavorButton.type = 'button';
      flavorButton.className = 'lsg-bundle-v2-showcase__flavor';
      flavorButton.setAttribute('data-bundle-showcase-flavor', variantId);
      flavorButton.setAttribute(
        'aria-label',
        this.getBundleText("showcaseSelectAriaTemplate", "Select {flavor}", { flavor: flavorName }));

      const swatch = document.createElement('span');
      swatch.className = 'lsg-bundle-v2-showcase__flavor-swatch';
      swatch.style.backgroundColor = flavorHex;

      const label = document.createElement('span');
      label.className = 'lsg-bundle-v2-showcase__flavor-label';
      label.textContent = flavorName;

      flavorButton.appendChild(swatch);
      flavorButton.appendChild(label);
      this.showcaseFlavors.appendChild(flavorButton);
    });
  }

  initShowcaseSwiper() {
    if (!this.showcaseSwiperEl || !this.showcaseTrack || !this.showcaseSlides.length) return;
    this.destroyShowcaseSwiper();
    const canSwipe = this.showcaseSlides.length > 1;
    this.showcaseSwiper = new Swiper(this.showcaseSwiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 650,
      allowTouchMove: canSwipe,
      simulateTouch: canSwipe,
      threshold: 4,
      resistanceRatio: 0.7,
      longSwipesMs: 260,
      longSwipesRatio: 0.2,
      followFinger: true,
      touchStartPreventDefault: false,
      touchMoveStopPropagation: false,
      passiveListeners: true,
      watchOverflow: true,
      observeParents: true,
      observer: true,
      nested: true,
      on: {
        slideChange: () => {
          const nextIndex = this.showcaseSwiper?.activeIndex || 0;
          this.setShowcaseSlide(nextIndex, { syncSwiper: false });
        },
        slideChangeTransitionEnd: () => {
          this.showcaseSwiperSyncing = false;
        },
      },
    });
  }

  destroyShowcaseSwiper() {
    if (!this.showcaseSwiper) return;
    this.showcaseSwiper.destroy(true, true);
    this.showcaseSwiper = null;
    this.showcaseSwiperSyncing = false;
  }

  renderShowcaseSlides() {
    if (!this.showcaseTrack || !this.showcaseThumbs || !this.showcaseDots) return;

    this.showcaseTrack.innerHTML = "";
    this.showcaseThumbs.innerHTML = "";
    this.showcaseDots.innerHTML = "";
    this.showcaseRoot.classList.toggle("has-multiple-slides", this.showcaseSlides.length > 1);

    this.showcaseSlides.forEach((slide, index) => {
      const slideEl = document.createElement('div');
      slideEl.className = 'lsg-bundle-v2-showcase__slide swiper-slide';

      const slideImage = document.createElement('img');
      slideImage.className = 'lsg-bundle-v2-showcase__main-image';
      slideImage.src = slide.src;
      slideImage.alt = slide.alt || this.getBundleText(
        "showcaseProductViewAltTemplate",
        "Product view {index}",
        { index: index + 1 });
      slideImage.loading = index === 0 ? 'eager' : 'lazy';
      slideEl.appendChild(slideImage);
      this.showcaseTrack.appendChild(slideEl);

      const thumbButton = document.createElement('button');
      thumbButton.type = 'button';
      thumbButton.className = 'lsg-bundle-v2-showcase__thumb';
      thumbButton.setAttribute('data-bundle-showcase-slide', String(index));
      thumbButton.setAttribute(
        'aria-label',
        this.getBundleText("showcaseViewImageAriaTemplate", "View image {index}", { index: index + 1 }));

      const thumbImage = document.createElement('img');
      thumbImage.src = slide.src;
      thumbImage.alt = slide.alt || this.getBundleText(
        "showcaseProductViewAltTemplate",
        "Product view {index}",
        { index: index + 1 });
      thumbImage.loading = index === 0 ? 'eager' : 'lazy';
      thumbButton.appendChild(thumbImage);

      this.showcaseThumbs.appendChild(thumbButton);

      const dotButton = document.createElement('button');
      dotButton.type = 'button';
      dotButton.className = 'lsg-bundle-v2-showcase__dot';
      dotButton.setAttribute('data-bundle-showcase-slide', String(index));
      dotButton.setAttribute(
        'aria-label',
        this.getBundleText("showcaseShowImageAriaTemplate", "Show image {index}", { index: index + 1 }));
      this.showcaseDots.appendChild(dotButton);
    });

    this.showcaseSlides.slice(0, 3).forEach((slide) => this.preloadShowcaseSlideImage(slide));
    this.initShowcaseSwiper();
  }

  setShowcaseCard(card, nextSlide = 0, options = {}) {
    if (!this.showcaseRoot || !this.showcaseTrack || !card) return;

    const preserveSlide = Boolean(options.preserveSlide);
    this.showcaseActiveCard = card;
    this.showcaseSlides = this.getShowcaseSlidesForCard(card);
    this.showcaseSlideIndex = preserveSlide ? this.showcaseSlideIndex : 0;

    if (!this.showcaseSlides.length) {
      this.showcaseTrack.innerHTML = "";
      this.showcaseMainImage = null;
      if (this.showcaseThumbs) this.showcaseThumbs.innerHTML = "";
      if (this.showcaseDots) this.showcaseDots.innerHTML = "";
      this.destroyShowcaseSwiper();
      return;
    }

    this.renderShowcaseSlides();

    const activeVariantId = card.getAttribute('data-lsg-bundle-v2-variant-select-id') || "";
    this.getShowcaseCards().forEach((item) => {
      item.classList.toggle('is-showcase-active', item === card);
    });
    if (this.showcaseFlavors) {
      this.showcaseFlavors.querySelectorAll('[data-bundle-showcase-flavor]').forEach((button) => {
        const isActive = button.getAttribute('data-bundle-showcase-flavor') === activeVariantId;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    const targetIndex = preserveSlide ? this.showcaseSlideIndex : nextSlide;
    this.setShowcaseSlide(targetIndex, { immediate: !preserveSlide });
  }

  setShowcaseSlide(nextIndex = 0, options = {}) {
    if (!this.showcaseSlides.length) return;
    const syncSwiper = options.syncSwiper !== false;
    const immediate = options.immediate === true;
    const totalSlides = this.showcaseSlides.length;
    const wrappedIndex = ((Number(nextIndex) % totalSlides) + totalSlides) % totalSlides;
    const activeSlide = this.showcaseSlides[wrappedIndex];
    if (!activeSlide) return;

    this.showcaseSlideIndex = wrappedIndex;
    if (this.showcaseRoot) {
      this.showcaseRoot.classList.toggle("is-first-slide", wrappedIndex === 0);
    }
    if (syncSwiper && this.showcaseSwiper && this.showcaseSwiper.activeIndex !== wrappedIndex) {
      this.showcaseSwiperSyncing = true;
      this.showcaseSwiper.slideTo(wrappedIndex, immediate ? 0 : 560, false);
      if (immediate) {
        this.showcaseSwiperSyncing = false;
      }
    }

    this.showcaseMainImage = this.getShowcaseImageByIndex(wrappedIndex) || this.showcaseMainImage;
    this.preloadShowcaseNeighborSlides(wrappedIndex);

    if (this.showcaseZoom && !this.showcaseZoom.hidden && this.showcaseZoomImage) {
      this.showcaseZoomImage.src = activeSlide.src;
      this.showcaseZoomImage.alt = activeSlide.alt || this.getBundleText("showcaseProductViewAlt", "Product view");
      this.resetShowcaseZoomScale();
    }

    if (this.showcaseThumbs) {
      this.showcaseThumbs.querySelectorAll('[data-bundle-showcase-slide]').forEach((button, index) => {
        const isActive = index === wrappedIndex;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    if (this.showcaseDots) {
      this.showcaseDots.querySelectorAll('[data-bundle-showcase-slide]').forEach((button, index) => {
        const isActive = index === wrappedIndex;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }
  }

  openShowcaseZoom() {
    if (!this.showcaseZoom || !this.showcaseZoomImage) return;
    const activeSlide = this.showcaseSlides[this.showcaseSlideIndex] || null;
    const activeImageElement = this.getActiveShowcaseImageElement();
    const zoomImageSrc =
      activeSlide?.src
      || activeImageElement?.currentSrc
      || activeImageElement?.src
      || "";
    if (!zoomImageSrc) return;

    this.showcaseZoomImage.src = zoomImageSrc;
    this.showcaseZoomImage.alt =
      activeSlide?.alt
      || activeImageElement?.alt
      || this.getBundleText("showcaseProductViewAlt", "Product view");
    this.resetShowcaseZoomScale();
    this.showcaseZoom.hidden = false;
    this.showcaseZoom.setAttribute("aria-hidden", "false");
    document.body.classList.add("lsg-bundle-v2-showcase-zoom-open");
    document.addEventListener("keydown", this.boundShowcaseZoomKeydown);
  }

  closeShowcaseZoom() {
    if (!this.showcaseZoom || this.showcaseZoom.hidden) return;
    this.showcaseZoom.hidden = true;
    this.showcaseZoom.setAttribute("aria-hidden", "true");
    this.resetShowcaseZoomScale();
    document.body.classList.remove("lsg-bundle-v2-showcase-zoom-open");
    document.removeEventListener("keydown", this.boundShowcaseZoomKeydown);
  }

  resetShowcaseZoomScale() {
    this.showcaseZoomScale = 1;
    if (this.showcaseZoom) {
      this.showcaseZoom.classList.remove("is-zoomed");
    }
    if (this.showcaseZoomImage) {
      this.showcaseZoomImage.style.transform = "scale(1)";
    }
    if (this.showcaseZoomToggle) {
      this.showcaseZoomToggle.textContent = this.getBundleText("zoomScaleInText", "2x");
    }
  }

  toggleShowcaseZoomScale() {
    if (!this.showcaseZoom || !this.showcaseZoomImage) return;
    this.showcaseZoomScale = this.showcaseZoomScale >= 2 ? 1 : 2;
    this.showcaseZoom.classList.toggle("is-zoomed", this.showcaseZoomScale > 1);
    this.showcaseZoomImage.style.transform = `scale(${this.showcaseZoomScale})`;
    if (this.showcaseZoomToggle) {
      this.showcaseZoomToggle.textContent = this.showcaseZoomScale > 1
        ? this.getBundleText("zoomScaleOutText", "1x")
        : this.getBundleText("zoomScaleInText", "2x");
    }
  }

  handleShowcaseZoomKeydown(event) {
    if (!this.showcaseZoom || this.showcaseZoom.hidden) return;
    if (event.key === "Escape") {
      event.preventDefault();
      this.closeShowcaseZoom();
      return;
    }

    if (event.key === "+" || event.key === "=" || event.key === "-" || event.key === "_") {
      event.preventDefault();
      this.toggleShowcaseZoomScale();
    }
  }

  preloadShowcaseSlideImage(slide) {
    const src = slide?.src || "";
    if (!src || this.showcaseImagePreloadCache.has(src)) return;
    const image = new Image();
    image.decoding = "async";
    image.src = src;
    this.showcaseImagePreloadCache.add(src);
  }

  preloadShowcaseNeighborSlides(activeIndex) {
    const totalSlides = this.showcaseSlides.length;
    if (totalSlides <= 1) return;
    [activeIndex - 1, activeIndex + 1].forEach((index) => {
      const wrappedIndex = ((index % totalSlides) + totalSlides) % totalSlides;
      this.preloadShowcaseSlideImage(this.showcaseSlides[wrappedIndex]);
    });
  }

  syncShowcaseWithSelection(preferredCard = null) {
    if (!this.showcaseRoot) return;
    const cards = this.getShowcaseCards();
    if (!cards.length) return;

    const selectedCards = cards.filter((card) => {
      const quantityInput = card.querySelector('.stay-ai-bundle-product-v2__quantity');
      return Number(quantityInput?.value || 0) > 0;
    });

    let nextCard = null;
    if (preferredCard && selectedCards.includes(preferredCard)) {
      nextCard = preferredCard;
    } else if (this.showcaseActiveCard && (selectedCards.includes(this.showcaseActiveCard) || selectedCards.length === 0)) {
      nextCard = this.showcaseActiveCard;
    } else {
      nextCard = selectedCards[0] || cards[0];
    }

    const shouldPreserveSlide = nextCard === this.showcaseActiveCard;
    this.setShowcaseCard(nextCard, shouldPreserveSlide ? this.showcaseSlideIndex : 0, {
      preserveSlide: shouldPreserveSlide,
    });
  }

  getDiscountConfigValue(settingKey, fallbackValue = 0) {
    const rawValue = Number(this.dataset?.[settingKey]);
    if (!Number.isFinite(rawValue)) return Number(fallbackValue || 0);
    return Math.max(0, Math.min(100, Math.round(rawValue)));
  }

  getConfiguredDiscountPercent(planType = "sub", bottleCount = 1) {
    const normalizedPlanType = String(planType || "").toLowerCase() === "otp" ? "otp" : "sub";
    const normalizedCount = Math.max(1, Number(bottleCount || 1));
    const tierKey = normalizedCount >= 3 ? "3" : String(normalizedCount);

    const defaultMap = {
      sub: { 1: 20, 2: 30, 3: 35 },
      otp: { 1: 0, 2: 10, 3: 18 },
    };

    const settingMap = {
      sub: {
        1: "bundleSubDiscount1",
        2: "bundleSubDiscount2",
        3: "bundleSubDiscount3",
      },
      otp: {
        1: "bundleOtpDiscount1",
        2: "bundleOtpDiscount2",
        3: "bundleOtpDiscount3",
      },
    };

    const settingKey = settingMap[normalizedPlanType][tierKey];
    return this.getDiscountConfigValue(
      settingKey,
      defaultMap[normalizedPlanType][tierKey]);
  }

  updateBundlePrice(trigger) {
    const oneTimePriceEls = this.querySelectorAll("[data-bundle-otp-price]");
    const subscriptionPriceEls = this.querySelectorAll("[data-bundle-sub-price]");
    const oneTimePerDayEls = this.querySelectorAll("[data-bundle-otp-price-day]");
    const subscriptionPerDayEls = this.querySelectorAll("[data-bundle-sub-price-day]");
    const otpSavePercentEls = this.querySelectorAll("[data-bundle-otp-save-percent]");
    const subSavePercentEls = this.querySelectorAll("[data-bundle-sub-save-percent]");
    const otpComparePriceEls = this.querySelectorAll("[data-bundle-otp-compare-price]");
    const totalPriceEls = this.querySelectorAll("[data-bundle-total]");
    const compareTotalEls = this.querySelectorAll("[data-bundle-compare-total]");
    const summarySaveEls = this.querySelectorAll("[data-bundle-summary-save]");
    const summaryPerDayEls = this.querySelectorAll("[data-bundle-summary-per-day]");
    const summaryQtyEls = this.querySelectorAll("[data-bundle-summary-qty]");
    const summaryProgressEls = this.querySelectorAll("[data-bundle-summary-progress]");
    const summaryUnlockedEls = this.querySelectorAll("[data-bundle-summary-unlocked]");
    const summarySwitchSaveEls = this.querySelectorAll("[data-bundle-summary-subsave]");
    const summarySwitchButtons = this.querySelectorAll(".lsg-bundle-v2-checkout-summary__switch");
    const productCardsBlock = this.querySelector('.stay-ai-bundle-product-v2__cards');
    const productCardsQtyInput = productCardsBlock
      ? Array.from(productCardsBlock.querySelectorAll(".stay-ai-bundle-product-v2__quantity"))
      : [];
    let interval = this.classList.contains("lsg-bundle-v2--otp-selected") ? "otp" : "sub";

    const currency = Shopify?.currency?.active || "USD";
    const currencyFormatter = new Intl.NumberFormat("en-US", {
      currency,
      style: "currency",
    });
    const savePrefix = this.getBundleText("savePrefix", "Save");
    const youSavePrefix = this.getBundleText("youSavePrefix", "YOU SAVE");
    const offUnlockedSuffix = this.getBundleText("offUnlockedSuffix", "OFF UNLOCKED");
    const standardPriceText = this.getBundleText("standardPriceText", "Standard Price");
    const addFlavorsText = this.getBundleText("addFlavorsText", "ADD FLAVORS");
    const unlockedText = (percentValue) => `${Math.max(0, Number(percentValue) || 0)}% ${offUnlockedSuffix}`.trim();

    const selectedChildQty = Math.max(0, this.getSelectedChildProductQty());
    const bottleCount = Math.max(1, selectedChildQty);
    const parseBottlePrice = (inputEl) => {
      const price = Number(inputEl?.dataset?.price);
      return Number.isFinite(price) && price > 0 ? price : 0;
    };
    const parseBottleAnchorPrice = (inputEl) => {
      const comparePrice = Number(inputEl?.dataset?.compareAtPrice);
      const price = parseBottlePrice(inputEl);
      if (Number.isFinite(comparePrice) && comparePrice > 0) {
        return Math.max(comparePrice, price);
      }
      return 0;
    };
    const selectedInput = productCardsQtyInput.find((inputEl) => {
      const qty = Number(inputEl?.value || 0);
      return qty > 0 && parseBottlePrice(inputEl) > 0;
    });
    const selectedAnchorInput = productCardsQtyInput.find((inputEl) => {
      const qty = Number(inputEl?.value || 0);
      return qty > 0 && parseBottleAnchorPrice(inputEl) > 0;
    });
    const firstPricedInput = productCardsQtyInput.find((inputEl) => parseBottlePrice(inputEl) > 0);
    const firstAnchorInput = productCardsQtyInput.find((inputEl) => parseBottleAnchorPrice(inputEl) > 0);
    const fallbackBottlePrice = Number(this.product?.price || 0);
    const baseBottlePrice = selectedInput
      ? parseBottlePrice(selectedInput)
      : firstPricedInput
        ? parseBottlePrice(firstPricedInput)
        : Number.isFinite(fallbackBottlePrice) && fallbackBottlePrice > 0
          ? fallbackBottlePrice
          : 0;
    const fallbackAnchorBottlePriceRaw = Number(this.dataset.bundleAnchorPrice || this.product?.compare_at_price || 0);
    const fallbackAnchorBottlePrice = Number.isFinite(fallbackAnchorBottlePriceRaw) && fallbackAnchorBottlePriceRaw > 0
      ? fallbackAnchorBottlePriceRaw
      : 0;
    const resolvedAnchorBottlePrice = selectedAnchorInput
      ? parseBottleAnchorPrice(selectedAnchorInput)
      : firstAnchorInput
        ? parseBottleAnchorPrice(firstAnchorInput)
        : fallbackAnchorBottlePrice;
    const anchorBottlePrice = resolvedAnchorBottlePrice > 0
      ? Math.max(resolvedAnchorBottlePrice, baseBottlePrice)
      : baseBottlePrice;

    const applyDiscount = (price, percent) => {
      if (!Number.isFinite(price) || price <= 0) return 0;
      return Math.max(0, Math.round(price * (100 - percent) / 100));
    };

    const subDiscountPercent = this.getConfiguredDiscountPercent("sub", bottleCount);
    const otpDiscountPercent = this.getConfiguredDiscountPercent("otp", bottleCount);
    const displayOtpPerBottle = applyDiscount(anchorBottlePrice, otpDiscountPercent);
    const displaySubPerBottle = applyDiscount(anchorBottlePrice, subDiscountPercent);

    const baseSubtotal = selectedChildQty > 0 ? anchorBottlePrice * selectedChildQty : 0;
    const displayOtpSubtotal = selectedChildQty > 0 ? displayOtpPerBottle * selectedChildQty : 0;
    const displaySubSubtotal = selectedChildQty > 0 ? displaySubPerBottle * selectedChildQty : 0;
    const displaySubSavePercent = subDiscountPercent;

    const daysPerBottleRaw = Number(this.dataset.bundleDaysPerBottle);
    const daysPerBottle = Number.isFinite(daysPerBottleRaw) && daysPerBottleRaw > 0
      ? daysPerBottleRaw
      : 30;
    const otpPerDay = displayOtpPerBottle / daysPerBottle;
    const subPerDay = displaySubPerBottle / daysPerBottle;
    const selectedSubtotal = selectedChildQty > 0
      ? interval === "otp" ? displayOtpSubtotal : displaySubSubtotal
      : 0;
    const selectedPerDay = interval === "otp" ? otpPerDay : subPerDay;
    const compareSubtotal = selectedChildQty > 0 ? baseSubtotal : 0;
    const savingsSubtotal = Math.max(0, compareSubtotal - selectedSubtotal);
    this.currentBundleTotalFormatted = currencyFormatter.format(selectedSubtotal / 100);

    oneTimePriceEls.forEach((el) => el.innerHTML = currencyFormatter.format(displayOtpPerBottle / 100));
    subscriptionPriceEls.forEach((el) => el.innerHTML = currencyFormatter.format(displaySubPerBottle / 100));
    otpComparePriceEls.forEach((el) => {
      el.textContent = anchorBottlePrice > displayOtpPerBottle
        ? currencyFormatter.format(anchorBottlePrice / 100)
        : "";
    });
    oneTimePerDayEls.forEach((el) => el.textContent = currencyFormatter.format(Math.max(0, otpPerDay) / 100));
    subscriptionPerDayEls.forEach((el) => el.textContent = currencyFormatter.format(Math.max(0, subPerDay) / 100));
    totalPriceEls.forEach((el) => {
      el.innerHTML = this.currentBundleTotalFormatted;
    });
    summaryPerDayEls.forEach((el) => {
      el.textContent = currencyFormatter.format(Math.max(0, selectedPerDay) / 100);
    });

    subSavePercentEls.forEach((el) => {
      el.textContent = `${displaySubSavePercent}%`;
    });

    const summaryProgressSteps = Math.max(0, Math.min(3, Math.floor(Math.max(selectedChildQty, 0))));

    compareTotalEls.forEach((el) => {
      el.textContent = compareSubtotal > 0
        ? currencyFormatter.format(compareSubtotal / 100)
        : "";
    });
    summarySaveEls.forEach((el) => {
      const selectedDiscountPercent = interval === "otp" ? otpDiscountPercent : subDiscountPercent;
      el.textContent = selectedChildQty > 0
        ? `${savePrefix} ${selectedDiscountPercent}%`
        : "";
    });
    summaryQtyEls.forEach((el) => {
      if (selectedChildQty > 0) {
        el.textContent = `x ${selectedChildQty}`;
        el.hidden = false;
      } else {
        el.textContent = "";
        el.hidden = true;
      }
    });
    summaryProgressEls.forEach((el, index) => {
      el.classList.toggle("is-active", index < summaryProgressSteps);
    });
    summaryUnlockedEls.forEach((el) => {
      if (interval === "otp") {
        if (selectedChildQty <= 1) {
          el.textContent = standardPriceText;
        } else {
          el.textContent = unlockedText(otpDiscountPercent);
        }
      } else {
        if (selectedChildQty <= 0) {
          el.textContent = addFlavorsText;
          return;
        }
        el.textContent = unlockedText(subDiscountPercent);
      }
    });

    summarySwitchSaveEls.forEach((el) => {
      el.textContent = subDiscountPercent > 0
        ? `${savePrefix} ${subDiscountPercent}%`
        : savePrefix;
    });
    summarySwitchButtons.forEach((button) => {
      button.hidden = interval !== "otp";
    });

    otpSavePercentEls.forEach((el) => {
      el.textContent = `${otpDiscountPercent}%`;
    });

    this.lastOtpSubtotal = displayOtpSubtotal;
    this.lastSubSubtotal = displaySubSubtotal;
    this.lastCompareSubtotal = compareSubtotal;
    this.lastSavingsSubtotal = savingsSubtotal;
    this.lastOtpDiscountPercent = otpDiscountPercent;
    this.lastSubDiscountPercent = subDiscountPercent;
    this.requestStickyOfferBarUpdate({
      otpSubtotal: displayOtpSubtotal,
      subSubtotal: displaySubSubtotal,
      compareSubtotal,
      savingsSubtotal,
      otpDiscountPercent,
      subDiscountPercent,
    });

    this.updateCtaText(this.classList.contains("bundle-checkout-enabled"));
  }

  updateCardHintLabels() {
    const label = this.getBundleText("flavorSelectButtonText", "Select");
    this.querySelectorAll(".lsg-bundle-v2-product-select-hint").forEach((hintEl) => {
      hintEl.textContent = label;
    });
    this.querySelectorAll(".stay-ai-bundle-product-v2__quantity-selector-add-text").forEach((textEl) => {
      textEl.textContent = label;
    });
    this.querySelectorAll(".lsg-bundle-v2-product-select-quantity-plus").forEach((buttonEl) => {
      buttonEl.setAttribute("aria-label", label);
    });
  }

  /**
   * Gets total quantity of selected child product
   * @returns {number}
   */
  getSelectedChildProductQty() {
    const productSetList = this.querySelector(".stay-ai-bundle-product-v2__cards");
    let quantity = 0;

    if (!productSetList) return -1;

    const productListQuantity = productSetList.querySelectorAll(".stay-ai-bundle-product-v2__quantity");
    productListQuantity.forEach((inputEl) => (quantity += Number(inputEl.value)));

    return quantity;
  }

  getCheckoutRequiredQuantity() {
    if (this.isV2MobileFlowEnabled() && this.v2Mode === "bundle") {
      return 2;
    }
    return 1;
  }

  getStickyOffset() {
    const announcementOffset = parseInt(
      document.body.style.getPropertyValue("--announcement-offset").replace("px", "")) || 0;
    const headerOffset = parseInt(
      document.body.style.getPropertyValue("--header-offset").replace("px", "")) || 0;
    return announcementOffset + headerOffset + 12;
  }

  setupPlanSummaryObserver() {
    const summary = this.querySelector("[data-bundle-plan-summary]");
    const plans = this.querySelector(".lsg-bundle-v2-plans");
    if (!summary || !plans) return;

    const updateVisibility = () => {
      const rect = plans.getBoundingClientRect();
      const offset = this.getStickyOffset() + 60;
      const shouldShow = rect.bottom <= offset;
      summary.classList.toggle("is-visible", shouldShow);
    };

    this.planSummaryUpdate = updateVisibility;
    window.addEventListener("scroll", updateVisibility, { passive: true });
    window.addEventListener("resize", updateVisibility);
    updateVisibility();
  }

  getFrequencySelect(trigger) {
    if (
      trigger &&
      trigger.classList &&
      trigger.classList.contains("lsg-bundle-v2-interval-frequency-select")
    ) {
      return trigger;
    }

    if (trigger && typeof trigger.closest === "function") {
      const intervalWrapper = trigger.closest(".lsg-bundle-v2-interval-select");
      if (intervalWrapper) {
        const select = intervalWrapper.querySelector(
          ".lsg-bundle-v2-interval-frequency-select");
        if (select) return select;
      }
    }

    return this.querySelector(".lsg-bundle-v2-interval-frequency-select");
  }

  syncFrequencySelects(selectedValue) {
    if (!selectedValue) return;
    this.querySelectorAll(".lsg-bundle-v2-interval-frequency-select").forEach(
      (select) => {
        if (select.value !== selectedValue) {
          select.value = selectedValue;
        }
      });
  }

  getMonthlyFrequencyValue(frequencySelect) {
    if (!frequencySelect) return "";
    const options = Array.from(frequencySelect.options || []);
    if (!options.length) return "";

    const matchers = [
      /\bmonth(?:ly)?\b/i,
      /\b4\s*weeks?\b/i,
      /\b30\s*days?\b/i,
      /\b28\s*days?\b/i,
    ];

    for (const matcher of matchers) {
      const monthlyOption = options.find((option) => {
        const label = option.textContent || "";
        const sellingPlanOptions = option.getAttribute("data-selling-plan-options") || "";
        return matcher.test(label) || matcher.test(sellingPlanOptions);
      });
      if (monthlyOption) return monthlyOption.value;
    }

    return options[0].value || "";
  }

  switchToMonthlySubscription(trigger) {
    const bundleBlock = this.getBundleBlock(trigger);
    if (!bundleBlock) return;

    const subIntervalInput = bundleBlock.querySelector(
      '.lsg-bundle-v2-interval-select input[name^="bundle_interval_select_"][value="sub"]');
    const frequencySelect = bundleBlock.querySelector(".lsg-bundle-v2-interval-frequency-select");

    if (!subIntervalInput || !frequencySelect) return;

    const monthlyFrequencyValue = this.getMonthlyFrequencyValue(frequencySelect);
    if (monthlyFrequencyValue && frequencySelect.value !== monthlyFrequencyValue) {
      frequencySelect.value = monthlyFrequencyValue;
      frequencySelect.dispatchEvent(new Event("change", { bubbles: true }));
    }

    if (!subIntervalInput.checked) {
      subIntervalInput.checked = true;
      subIntervalInput.dispatchEvent(new Event("change", { bubbles: true }));
      return;
    }

    this.updateInterval(subIntervalInput);
    this.updateFrequency(frequencySelect);
    this.checkoutEnableValidation(subIntervalInput);
    this.setUrl(subIntervalInput);
  }

  handleUnlockPerks(event) {
    event.preventDefault();
    this.switchToMonthlySubscription(event.currentTarget);
  }

  
  getBundleInterval(trigger) {
      //checks if the bundle is set to display OTP or suscription options
      let bundleBlock = this.getBundleBlock(trigger);
      if(bundleBlock.classList.contains('lsg-bundle-v2--has-interval-select')) {
          if(bundleBlock.classList.contains('lsg-bundle-v2--otp-selected')) {
              return 'otp';
          }
          if(bundleBlock.classList.contains('lsg-bundle-v2--sub-selected')) {
              return 'sub';
          }
      }
      if(bundleBlock.classList.contains('lsg-bundle-v2--only-otp')) {
          return 'otp';
      }
      if(bundleBlock.classList.contains('lsg-bundle-v2--only-sub')) {
          return 'sub';
      }
      return 'err';
  }

  /**
   * Get selected bundle block
   * @param {HTMLElement} trigger
   * @returns {HTMLElement}
   */
  getBundleBlock(trigger) {
    return trigger.closest('.lsg-bundle-v2-block');
  }

  getBundleBlocks() {
    const bundleWrapper = this.closest('.lsg-bundle-v2-wrapper');
    if (!bundleWrapper) return [];
    return Array.from(bundleWrapper.querySelectorAll('.lsg-bundle-v2-block'));
  }

  parseBundleTitleTier(bundleTitle = "") {
    const title = String(bundleTitle || "").trim();
    const numberMatch = title.match(/(\d+)/);
    if (!numberMatch) return null;

    const quantity = Number(numberMatch[1]);
    if (!Number.isFinite(quantity) || quantity <= 0) return null;

    const isPlusTier = title.includes("+");
    return {
      quantity,
      mode: isPlusTier ? "min" : "exact",
    };
  }

  resolveBundleBlockForQuantity(quantity) {
    const totalQty = Number(quantity);
    if (!Number.isFinite(totalQty) || totalQty <= 0) return this;

    const bundleBlocks = this.getBundleBlocks();
    if (!bundleBlocks.length) return this;
    if (bundleBlocks.length === 1) return bundleBlocks[0];

    const bundleTiers = bundleBlocks
      .map((bundleBlock, index) => {
        const title = bundleBlock.getAttribute("data-bundle-title") || "";
        return {
          bundleBlock,
          index,
          tier: this.parseBundleTitleTier(title),
        };
      })
      .filter((item) => item.tier);

    const exactMatch = bundleTiers
      .filter((item) => item.tier.mode === "exact" && item.tier.quantity === totalQty)
      .sort((a, b) => a.index - b.index)[0];
    if (exactMatch) return exactMatch.bundleBlock;

    const plusMatch = bundleTiers
      .filter((item) => item.tier.mode === "min" && totalQty >= item.tier.quantity)
      .sort((a, b) => b.tier.quantity - a.tier.quantity)[0];
    if (plusMatch) return plusMatch.bundleBlock;

    const lowerExactMatch = bundleTiers
      .filter((item) => item.tier.mode === "exact" && totalQty >= item.tier.quantity)
      .sort((a, b) => b.tier.quantity - a.tier.quantity)[0];
    if (lowerExactMatch) return lowerExactMatch.bundleBlock;

    // Fallback for legacy titles without parseable numbers: 2 -> middle, 3+ -> last.
    if (bundleBlocks.length >= 3 && totalQty >= 3) return bundleBlocks[2];
    if (bundleBlocks.length >= 2 && totalQty >= 2) return bundleBlocks[1];

    return bundleBlocks[0] || this;
  }

  resolveSubscriptionParentBundleBlock() {
    const bundleBlocks = this.getBundleBlocks();
    if (!bundleBlocks.length) return this;
    if (bundleBlocks.length === 1) return bundleBlocks[0];

    const bundleTierMeta = bundleBlocks.map((bundleBlock, index) => {
      const title = bundleBlock.getAttribute("data-bundle-title") || "";
      const tier = this.parseBundleTitleTier(title);
      const min = Number(bundleBlock.getAttribute("bundle-min"));
      const max = Number(bundleBlock.getAttribute("bundle-max"));
      return {
        bundleBlock,
        index,
        tier,
        min: Number.isFinite(min) ? min : 0,
        max: Number.isFinite(max) ? max : 0,
      };
    });

    const plusTierMatch = bundleTierMeta
      .filter((item) => item.tier?.mode === "min")
      .sort((a, b) =>
        (b.tier.quantity - a.tier.quantity) ||
        (b.max - a.max) ||
        (b.min - a.min) ||
        (b.index - a.index)
      )[0];
    if (plusTierMatch) return plusTierMatch.bundleBlock;

    const widestRangeMatch = bundleTierMeta
      .filter((item) => item.max > 0)
      .sort((a, b) =>
        (b.max - a.max) ||
        (b.min - a.min) ||
        (b.index - a.index)
      )[0];
    if (widestRangeMatch) return widestRangeMatch.bundleBlock;

    return bundleBlocks[bundleBlocks.length - 1] || this;
  }

  getSellingPlanForBundle(
    targetBundleBlock,
    sourceBundleBlock = this,
    { ignoreSubscriptionState = false } = {}) {
    if (!targetBundleBlock) {
      return "";
    }
    const sourceIsSubscription = sourceBundleBlock?.classList?.contains("lsg-bundle-v2--sub-selected");
    if (!ignoreSubscriptionState && !sourceIsSubscription) return "";

    const sourceFrequencySelect = sourceBundleBlock.querySelector(
      ".lsg-bundle-v2-interval-frequency-select");
    const targetFrequencySelect = targetBundleBlock.querySelector(
      ".lsg-bundle-v2-interval-frequency-select");

    if (!targetFrequencySelect) return "";
    if (!sourceFrequencySelect) return targetFrequencySelect.value || "";

    const sourceValue = String(sourceFrequencySelect.value || "");
    if (sourceValue) {
      const exactValueOption = Array.from(targetFrequencySelect.options || []).find(
        (option) => String(option.value || "") === sourceValue);
      if (exactValueOption) return exactValueOption.value || "";
    }

    const sourceLabel = String(
      sourceFrequencySelect.options[sourceFrequencySelect.selectedIndex]?.textContent || "")
      .toLowerCase()
      .replace(/\s+/g, " ")
      .trim();
    if (sourceLabel) {
      const labelMatchOption = Array.from(targetFrequencySelect.options || []).find((option) => {
        const optionLabel = String(option.textContent || "")
          .toLowerCase()
          .replace(/\s+/g, " ")
          .trim();
        return optionLabel === sourceLabel;
      });
      if (labelMatchOption) return labelMatchOption.value || "";
    }

    return targetFrequencySelect.value || "";
  }

  getFallbackSellingPlanForBundle(targetBundleBlock, sourceBundleBlock = this) {
    const matchedPlan = this.getSellingPlanForBundle(
      targetBundleBlock,
      sourceBundleBlock,
      { ignoreSubscriptionState: true });
    if (matchedPlan) return matchedPlan;
    const targetFrequencySelect = targetBundleBlock?.querySelector(
      ".lsg-bundle-v2-interval-frequency-select");
    return targetFrequencySelect?.options?.[0]?.value || "";
  }

  requiresSellingPlanForSelection(selectedInputs = [], bundleBlock = this) {
    const parentRequiresRaw = String(
      bundleBlock?.dataset?.bundleParentRequiresPlan || this.dataset?.bundleParentRequiresPlan || "")
      .trim()
      .toLowerCase();
    const parentRequiresSellingPlan = parentRequiresRaw === "true" || parentRequiresRaw === "1";
    const childRequiresSellingPlan = selectedInputs.some((inputEl) => {
      const rawValue = String(inputEl?.dataset?.requiresSellingPlan || "").trim().toLowerCase();
      return rawValue === "true" || rawValue === "1";
    });
    return parentRequiresSellingPlan || childRequiresSellingPlan;
  }

  getUpgradeData(bundleSellingPlan, sourceBundleBlock = this, frequencySourceBlock = sourceBundleBlock) {
    const bundleBlocks = this.getBundleBlocks();
    if (bundleBlocks.length < 2) return null;
    const bundleIndex = bundleBlocks.indexOf(sourceBundleBlock);
    if (bundleIndex < 0 || bundleIndex >= bundleBlocks.length - 1) return null;

    const upgradeBlock = bundleBlocks[bundleIndex + 1];
    if (!upgradeBlock) return null;

    const upgradeParentInput = upgradeBlock.querySelector('.lsg-bundle-v2-form input[name="id"]');
    if (!upgradeParentInput) return null;

    const upgradeData = {
      parentId: upgradeParentInput.value,
      min: upgradeBlock.getAttribute('bundle-min') || '',
      max: upgradeBlock.getAttribute('bundle-max') || '',
      title: upgradeBlock.getAttribute('data-bundle-title') || '',
      handle: upgradeBlock.getAttribute('data-bundle-handle') || '',
      collection: upgradeBlock.getAttribute('data-bundle-collection') || '',
      sellingPlanId: '',
    };

    if (bundleSellingPlan) {
      const currentFrequencySelect = frequencySourceBlock?.querySelector('.lsg-bundle-v2-interval-frequency-select');
      const upgradeFrequencySelect = upgradeBlock.querySelector('.lsg-bundle-v2-interval-frequency-select');
      if (upgradeFrequencySelect) {
        if (currentFrequencySelect && currentFrequencySelect.selectedIndex >= 0) {
          upgradeData.sellingPlanId =
            upgradeFrequencySelect.options[currentFrequencySelect.selectedIndex]?.value || upgradeFrequencySelect.value;
        } else {
          upgradeData.sellingPlanId = upgradeFrequencySelect.value;
        }
      }
    }

    return upgradeData;
  }

  /**
   * Get unique ID for Bundle products
   * @returns {String}
   */
  getGuid() {
    let d = new Date().getTime();
    let d2 =  (performance && performance.now && (performance.now() * 1000)) || 0;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      let r = Math.random() * 16;
      if (d > 0) {
        r = (d + r) % 16 | 0;
        d = Math.floor(d / 16);
      } else {
        r = (d2 + r) % 16 | 0;
        d2 = Math.floor(d2 / 16);
      }
      return (c == 'x' ? r: (r & 0x7 | 0x8)).toString(16);
    });
  }

  getSelectedProductsFromInputs() {
    const selectedProductData = [];
    const maxSelection = this.bundleMax > 0 ? this.bundleMax : Number.POSITIVE_INFINITY;
    const productCards = this.querySelectorAll(".lsg-bundle-v2-product-select-wrapper");

    productCards.forEach((productCard) => {
      const quantityInput = productCard.querySelector(".stay-ai-bundle-product-v2__quantity");
      const selectedQuantity = Number(quantityInput?.value || 0);
      if (!Number.isFinite(selectedQuantity) || selectedQuantity <= 0) return;

      const productImage = productCard.querySelector(".lsg-bundle-v2-product-select-img-wrap img");
      const productTitle =
        productCard.querySelector(".lsg-bundle-v2-product-select-title")?.textContent?.trim() || "";
      const variantID = productCard.getAttribute("data-lsg-bundle-v2-variant-select-id") || "";

      for (let i = 0; i < selectedQuantity; i += 1) {
        if (selectedProductData.length >= maxSelection) break;
        selectedProductData.push({
          selectedProductImageUrl: productImage?.src || "",
          selectedVariantId: variantID,
          selectedProductTitle: productTitle,
          selectedProductImageAlt: productImage?.alt || productTitle,
        });
      }
    });

    return selectedProductData;
  }

  /**
   * Groups all selected products
   * @param {HTMLElement} trigger - Selected quantity input
   */
  buildSelectedProductArray = () => {
    const bundleIndex0 = this.parentNode ? [...this.parentNode.children].indexOf(this) : -1;
    if (bundleIndex0 < 0) return;
    if (!Array.isArray(this.selectedProducts)) {
      this.selectedProducts = [];
    }
    this.selectedProducts[bundleIndex0] = this.getSelectedProductsFromInputs();
    this.updateSelectedProductGUI();
  }

  updateSelectedProductGUI = () => {
    const bundleIndex0 = this.parentNode ? [...this.parentNode.children].indexOf(this) : -1;
    if (bundleIndex0 < 0) return;
    if (!Array.isArray(this.selectedProducts)) {
      this.selectedProducts = [];
    }
    this.selectedProducts[bundleIndex0] = this.getSelectedProductsFromInputs();
    const matchingSelectedProducts = this.selectedProducts[bundleIndex0] || [];
    
    if (!matchingSelectedProducts) return;
    if (!this.selectedProductsWrapper || !this.selectedProductsWrapper.forEach) return;

    this.classList.toggle("has-selected-product", matchingSelectedProducts.length > 0)

    this.selectedProductsWrapper.forEach((selections) => {
      const variantSelectors = selections?.querySelectorAll('[data-bundle-builder-selected-variant-id]');
      [...variantSelectors].forEach((productWrapper, i) => {

        const selectedProductData = matchingSelectedProducts[i];
        const productWrapperImage = productWrapper.querySelector("[data-bundle-builder-selected-product-image]");
        const productWrapperTitle = productWrapper.querySelector("[data-bundle-builder-selected-product-title]");
        productWrapper.setAttribute("data-bundle-builder-selected-variant-id", selectedProductData?.selectedVariantId || '');
        productWrapperImage.src = selectedProductData?.selectedProductImageUrl || "";
        productWrapperImage.alt = selectedProductData?.selectedProductImageAlt || "";
        productWrapperTitle.innerHTML = selectedProductData?.selectedProductTitle || "";
        
        selectedProductData ? productWrapper.classList.add("active") : productWrapper.classList.remove("active");
      }); 
    })
    this.syncShowcaseWithSelection();
  }

  resetBundleSelections({ clearUrl = false } = {}) {
    const bundleIndex0 = [...this.parentNode.children].indexOf(this);
    if (Array.isArray(this.selectedProducts)) {
      this.selectedProducts[bundleIndex0] = [];
    }

    this.querySelectorAll('.stay-ai-bundle-product-v2__quantity').forEach((input) => {
      input.value = 0;
      this.updateQuantityDisplay(input);
    });

    this.updateSelectedProductGUI();
    this.totalSelectedQtyValidation();
    this.checkoutEnableValidation();
    this.updateBundlePrice();
    this.clearRequiredMessage();

    if (this.isV2MobileFlowEnabled()) {
      this.v2Mode = "single";
      this.v2StructureChosen = true;
      this.v2SingleQuantity = 1;
      this.v2BundleQuantity = 1;
      this.v2SingleVariantId = "";
      this.v2BundleSlots = ["", "", ""];
      this.v2ActiveSlot = -1;
      this.v2PlanWasUnlocked = false;
      this.v2FlowInitialized = true;
      this.updateV2FlowUi();
    }

    if (clearUrl) {
      this.clearBundleParams();
    }
  }

  clearBundleParams() {
    try {
      const params = new URLSearchParams(window.location.search);
      Object.values(BUNDLE_V2_URL_KEYS).forEach((key) => params.delete(key));
      if (this.shouldUseLegacyCompatibility()) {
        Object.values(BUNDLE_V2_LEGACY_URL_KEYS).forEach((key) => params.delete(key));
      }
      const query = params.toString();
      const nextUrl = `${window.location.pathname}${query ? `?${query}` : ""}${window.location.hash || ""}`;
      if (window.history && window.history.replaceState) {
        window.history.replaceState({ path: nextUrl }, "", nextUrl);
      }
    } catch (error) {
      // ignore URL update failures
    }
  }

  /**
   * Sets active bundle on enabled grouped bundles
   * @param {HTMLElement} trigger - Selected grouped bundle element
   */
  setActiveBundle(trigger) {
    const bundleIndex = trigger.dataset.bundleIndex;
    const bundleWrapper = trigger.closest('.lsg-bundle-v2-wrapper');
    const bundleBlocks = bundleWrapper.querySelectorAll('.lsg-bundle-v2-block');
    const targetBundle = bundleWrapper.querySelector(`[bundle-index="${bundleIndex}"].lsg-bundle-v2-block`);
    
    if(targetBundle) {
      bundleBlocks.forEach((bundleBlock) => {
        if(bundleBlock.bundleIndex != bundleIndex) {
          bundleBlock.classList.remove('lsg-bundle-v2-block-active');
        } else {
           bundleBlock.classList.add('lsg-bundle-v2-block-active');
        }
      });
      this.updateSelectedProductGUI(trigger);
      if (targetBundle && targetBundle.updateBundlePrice) {
        targetBundle.updateBundlePrice();
        targetBundle.checkoutEnableValidation();
        if (typeof targetBundle.updatePlanSummary === "function") {
          targetBundle.updatePlanSummary();
        }
        if (typeof targetBundle.planSummaryUpdate === "function") {
          targetBundle.planSummaryUpdate();
        }
        if (typeof targetBundle.scrollPlanIntoView === "function") {
          targetBundle.scrollPlanIntoView();
        }
      if (typeof targetBundle.updateStickyObserverState === "function") {
          targetBundle.updateStickyObserverState();
        }
      }
      this.setUrl(targetBundle.querySelector('form') || targetBundle);
      if (typeof targetBundle.persistBundleState === "function") {
        targetBundle.persistBundleState();
      }
    }
  }

  getBundleUrlState() {
    const params = new URLSearchParams(window.location.search);
    const hasV2Params = Object.values(BUNDLE_V2_URL_KEYS).some((key) => params.has(key));
    const canUseLegacyParams = this.shouldUseLegacyCompatibility();
    const hasLegacyParams = canUseLegacyParams
      ? Object.values(BUNDLE_V2_LEGACY_URL_KEYS).some((key) => params.has(key))
      : false;
    if (!hasV2Params && !hasLegacyParams) {
      return null;
    }

    const activeKeys = hasV2Params ? BUNDLE_V2_URL_KEYS : BUNDLE_V2_LEGACY_URL_KEYS;
    return {
      params,
      activeKeys,
      hasLegacyParams: !hasV2Params && hasLegacyParams,
      bundles: params.getAll(activeKeys.items),
      bundleIndexes: params.getAll(activeKeys.index),
      intervals: params.getAll(activeKeys.interval),
      frequencies: params.getAll(activeKeys.frequency),
    };
  }

  /**
   * Check preset URL params
   */
  checkParameter() {
    const urlState = this.getBundleUrlState();
    if (!urlState) return false;

    const bundleBlocks = Array.from(document.querySelectorAll(".lsg-bundle-v2-block"));
    if (!bundleBlocks.length) return false;

    const bundleIndex = Number(urlState.bundleIndexes[0] || 0);
    const normalizedBundleIndex = Number.isFinite(bundleIndex) && bundleIndex >= 0
      ? Math.min(bundleIndex, bundleBlocks.length - 1)
      : 0;
    const bundleBlock = bundleBlocks[normalizedBundleIndex] || bundleBlocks[0];
    if (!bundleBlock) return false;

    if (normalizedBundleIndex > 0) {
      const bundleBlockSelects = document.querySelectorAll(".lsg-bundle-v2-size-select .lsg-bundle-v2-size-select-el");
      const selectedBundleCard = bundleBlockSelects[normalizedBundleIndex];
      if (selectedBundleCard) {
        selectedBundleCard.click();
      }
    }

    urlState.bundles.forEach((entry) => {
      const [id, quantity] = String(entry || "").split("_");
      const quantityInput = bundleBlock.querySelector(`.stay-ai-bundle-product-v2__quantity[data-product="${id}"]`);
      this.updateQuantityInput(quantityInput, quantity);
    });

    urlState.intervals.forEach((el) => {
      const packSizeSelectorItem = bundleBlock.querySelector(`.lsg-bundle-v2-interval-select input[name^="bundle_interval_select_"][value="${el}"]`);
      if (!packSizeSelectorItem) return;

      packSizeSelectorItem.checked = true;
      this.updateInterval(packSizeSelectorItem);
      this.checkoutEnableValidation(packSizeSelectorItem);
    });

    urlState.frequencies.forEach((el) => {
      const bundleIntervalFrequencySelect = bundleBlock.querySelector('.lsg-bundle-v2-interval-frequency-select');

      if (!bundleIntervalFrequencySelect) return;

      bundleIntervalFrequencySelect.value = el;
      this.updateFrequency(bundleIntervalFrequencySelect);
    });

    if (this.isV2MobileFlowEnabled()) {
      this.hydrateV2FlowStateFromInputs();
      this.updateV2FlowUi();
    }

    if (urlState.hasLegacyParams) {
      this.setUrl(bundleBlock.querySelector("form") || bundleBlock);
    }

    this.persistBundleState();
    return true;
  }

  /**
   * Updates individual product selection quantity inputs
   * @param {HTMLElement} quantityInput - Child product quantity input element
   * @param {Number} quantity - Total selected quantity on child product
   * 
   */
  updateQuantityInput(quantityInput, quantity) {
    if (!quantityInput) return;
    const normalizedQuantity = Math.max(0, parseInt(quantity, 10) || 0);
    if (normalizedQuantity <= 0) return;

    quantityInput.value = normalizedQuantity - 1;
    const quantityInputPlus = quantityInput.closest(".stay-ai-bundle-product-v2__quantity-wrapper").querySelector(`.stay-ai-bundle-product-v2__quantity-selector--plus`);

    for (let i = 0; i < normalizedQuantity; i++) {
      quantityInput.value = i;
      this.toggleProductQuantity(quantityInputPlus);
      this.buildSelectedProductArray(quantityInputPlus);
      this.totalSelectedQtyValidation(quantityInputPlus);
      this.checkoutEnableValidation(quantityInputPlus);
    }
  }

  /**
   * Set bundle url params
   * @param {EventListener} clickedEl - Clicked element event listener
   */
  setUrl(clickedEl) {
    const trigger = clickedEl || this;
    const bundleBlockWrapper = trigger.closest
      ? trigger.closest(".lsg-bundle-v2-wrapper")
      : this.closest(".lsg-bundle-v2-wrapper");
    if (bundleBlockWrapper && !bundleBlockWrapper.hasAttribute('data-lsg-bundle-v2-set-url')) {
      return false;
    }

    const bundleBlock = this.getBundleBlock(trigger);
    if (!bundleBlock) return false;

    const params = new URLSearchParams(window.location.search);
    Object.values(BUNDLE_V2_URL_KEYS).forEach((key) => params.delete(key));
    if (this.shouldUseLegacyCompatibility()) {
      Object.values(BUNDLE_V2_LEGACY_URL_KEYS).forEach((key) => params.delete(key));
    }

    bundleBlock.querySelectorAll(".stay-ai-bundle-product-v2__quantity").forEach((inputEl) => {
      const value = Number(inputEl.value) || 0;
      if (value <= 0) return;
      const productId = inputEl.getAttribute("data-product");
      if (!productId) return;
      params.append(BUNDLE_V2_URL_KEYS.items, `${productId}_${value}`);
    });

    const selectedBundle = bundleBlock
      .closest(".lsg-bundle-v2-wrapper")
      ?.querySelector(".lsg-bundle-v2-block.lsg-bundle-v2-block-active");
    if (selectedBundle) {
      params.set(
        BUNDLE_V2_URL_KEYS.index,
        String(Array.from(selectedBundle.parentNode.children).indexOf(selectedBundle)));
    }

    const bundleIntervalOption = bundleBlock.querySelector('.lsg-bundle-v2-interval-select input[type="radio"]:checked');
    if (bundleIntervalOption) {
      params.set(BUNDLE_V2_URL_KEYS.interval, bundleIntervalOption.value);
      if (bundleIntervalOption.value === "sub") {
        const bundleIntervalFrequencySelect = bundleBlock.querySelector('.lsg-bundle-v2-interval-frequency-select');
        if (bundleIntervalFrequencySelect?.value) {
          params.set(BUNDLE_V2_URL_KEYS.frequency, bundleIntervalFrequencySelect.value);
        }
      }
    }

    const query = params.toString();
    const nextUrl = `${window.location.pathname}${query ? `?${query}` : ""}${window.location.hash || ""}`;
    if (window.history && window.history.pushState) {
      window.history.pushState({ path: nextUrl }, "", nextUrl);
    }
    return true;
  }

  /**
   * Validation to make sure total selected quantity doesn't exceed max or min value
   */
  totalSelectedQtyValidation() {
    const productSetList = this.querySelector('.stay-ai-bundle-product-v2__cards');
    const quantityIncrementButtons = productSetList.querySelectorAll('.stay-ai-bundle-product-v2__quantity-selector');
    const bundleQuantity = this.getSelectedChildProductQty();
    const bundleMax = productSetList.dataset.bundleMax || 0;

    quantityIncrementButtons.forEach((quantitySelector) => {
      const productDetails = quantitySelector.parentElement.querySelector(".stay-ai-bundle-product-v2__quantity");
      const totalQty = productDetails.value;
      const maxValue = Number(productDetails.max);
      const minValue = Number(productDetails.min);
      const selectorType = quantitySelector.classList.contains("stay-ai-bundle-product-v2__quantity-selector--minus")
        ? "minus"
        : "plus";

      quantitySelector.disabled = selectorType === "minus"
        ? totalQty <= 0 || totalQty <= minValue
        : totalQty >= maxValue || (Number(bundleMax) > 0 && bundleQuantity >= Number(bundleMax));
    });

    const maxReached = Number(bundleMax) > 0 && bundleQuantity >= Number(bundleMax);
    this.querySelectorAll('.lsg-bundle-v2-product-select-wrapper').forEach((productCard) => {
      const quantityInput = productCard.querySelector('.stay-ai-bundle-product-v2__quantity');
      const quantity = Number(quantityInput?.value || 0);
      productCard.classList.toggle('is-selected', quantity > 0);
      productCard.classList.toggle('is-locked', maxReached && quantity <= 0);
    });

    if (typeof this.updateFlavorSelectionHelper === "function") {
      this.updateFlavorSelectionHelper();
    }
    if (typeof this.updateSelectedProductGUI === "function") {
      this.updateSelectedProductGUI();
    }
    if (typeof this.updateStickySummary === "function") {
      this.updateStickySummary();
    }
    if (typeof this.updateStickyOfferBar === "function") {
      this.requestStickyOfferBarUpdate({
        otpSubtotal: this.lastOtpSubtotal,
        subSubtotal: this.lastSubSubtotal,
        compareSubtotal: this.lastCompareSubtotal,
      });
    }
  }

  /**
   * Check if bundled products can get added to cart
   */
  checkoutEnableValidation() {
    const bundleQuantity = this.getSelectedChildProductQty();
    const requiredQuantity = this.getCheckoutRequiredQuantity();
    const quantityToAdd = Math.max(0, requiredQuantity - bundleQuantity);
    const hasRequiredProductQuantity =
      bundleQuantity >= requiredQuantity
      && (bundleQuantity <= this.bundleMax || this.bundleMax < requiredQuantity || this.bundleMax <= 0);
    const isCtaProgressLocked =
      this.atcProgressState === "adding" || this.atcProgressState === "added";
    
    this.hasRequiredProductQuantity = hasRequiredProductQuantity;
    const buttons = this.querySelectorAll("[data-bundle-atc]");
    if (!buttons.length) return;

    if (!isCtaProgressLocked) {
      buttons.forEach((button) => {
        button.disabled = false;
        button.setAttribute("aria-disabled", "false");
        button.classList.remove("disabled");
      });
    }
    this.classList.toggle("bundle-checkout-enabled", hasRequiredProductQuantity);
    if (this.addToCartButtonQuantity && !isCtaProgressLocked) {
      this.addToCartButtonQuantity.innerHTML = hasRequiredProductQuantity ? "" : quantityToAdd;
    }
    if (!isCtaProgressLocked) {
      this.updateCtaText(hasRequiredProductQuantity);
    }
    if (hasRequiredProductQuantity) {
      this.clearRequiredMessage();
    }
    if (typeof this.updateFlavorSelectionHelper === "function") {
      this.updateFlavorSelectionHelper();
    }
  }

  scrollPlanIntoView() {
    const planGrid = this.querySelector(".lsg-bundle-v2-plan-grid");
    if (!planGrid) return;
    if (!window.matchMedia("(max-width: 900px)").matches) return;
    if (!this.classList.contains("lsg-bundle-v2-block-active")) return;

    const targetPlan = planGrid.querySelector(".lsg-bundle-v2-plan-card.lsg-bundle-v2-size-select-el--selected")
      || planGrid.querySelector(".lsg-bundle-v2-plan-card--featured")
      || planGrid.querySelector(".lsg-bundle-v2-plan-card");

    if (!targetPlan) return;

    window.requestAnimationFrame(() => {
      const gridRect = planGrid.getBoundingClientRect();
      const cardRect = targetPlan.getBoundingClientRect();
      const offset = (cardRect.left - gridRect.left) - (gridRect.width - cardRect.width) / 2;
      planGrid.scrollTo({ left: planGrid.scrollLeft + offset, behavior: "auto" });
    });
  }

  updateCtaText(hasRequiredProductQuantity) {
    const buttons = this.querySelectorAll("[data-bundle-atc]");
    if (!buttons.length) return;
    if (this.atcProgressState === "adding" || this.atcProgressState === "added") {
      return;
    }
    const requiredQuantity = this.getCheckoutRequiredQuantity();
    const chooseSingleText = this.getBundleText("chooseFlavorText", "CHOOSE FLAVOR");
    const chooseMultipleTemplate = this.getBundleText("chooseFlavorsText", "CHOOSE {count} FLAVORS");
    const chooseText = requiredQuantity <= 1
      ? chooseSingleText
      : this.formatBundleText(chooseMultipleTemplate, { count: requiredQuantity });
    const addToCartText = this.getBundleText("ctaAddToCartText", "ADD TO CART");

    const activePlan = this.querySelector(".lsg-bundle-v2-plan-card.lsg-bundle-v2-size-select-el--selected")
      || this.querySelector(".lsg-bundle-v2-plan-card");
    const planDaily = activePlan?.dataset?.planDaily || "";
    let subtitleText = "";

    if (hasRequiredProductQuantity) {
      if (planDaily) {
        subtitleText = `${planDaily} / day`;
      }
    }

    buttons.forEach((button) => {
      const titleEl = button.querySelector("[data-bundle-atc-title]");
      const subtitleEl = button.querySelector("[data-bundle-atc-subtitle]");

      if (hasRequiredProductQuantity) {
        if (titleEl) titleEl.textContent = addToCartText;
        if (subtitleEl) subtitleEl.textContent = "";
        button.classList.add("is-ready");
        button.classList.remove("is-checkout");
      } else {
        if (titleEl) titleEl.textContent = chooseText;
        if (subtitleEl) subtitleEl.textContent = "";
        button.classList.remove("is-ready");
        button.classList.remove("is-checkout");
      }
    });
  }

  setAtcProgressState(state = "idle") {
    const buttons = this.querySelectorAll("[data-bundle-atc]");
    this.atcProgressState = state;
    if (!buttons.length) return;

    const isAdding = state === "adding";
    const isAdded = state === "added";
    const addingText = this.getBundleText("ctaAddingText", "ADDING...");
    const addedText = this.getBundleText("ctaAddedText", "ADDED");

    buttons.forEach((button) => {
      const titleEl = button.querySelector("[data-bundle-atc-title]");

      if (isAdding) {
        if (titleEl) titleEl.textContent = addingText;
        button.disabled = true;
        button.setAttribute("aria-disabled", "true");
        button.classList.add("is-adding");
        button.classList.remove("is-added");
        return;
      }

      if (isAdded) {
        if (titleEl) titleEl.textContent = addedText;
        button.disabled = true;
        button.setAttribute("aria-disabled", "true");
        button.classList.remove("is-adding");
        button.classList.add("is-added");
        return;
      }

      button.classList.remove("is-adding");
      button.classList.remove("is-added");
      button.disabled = false;
      button.setAttribute("aria-disabled", "false");
    });

    if (state === "idle") {
      this.checkoutEnableValidation();
    }
  }

  updatePlanSummary() {
    const summary = this.querySelector("[data-bundle-plan-summary]");
    if (!summary) return;

    const activePlan = this.querySelector(".lsg-bundle-v2-plan-card.lsg-bundle-v2-size-select-el--selected")
      || this.querySelector(".lsg-bundle-v2-plan-card--featured")
      || this.querySelector(".lsg-bundle-v2-plan-card");
    if (!activePlan) return;

    let title =
      activePlan.dataset?.planTitle
      || activePlan.querySelector(".lsg-bundle-v2-plan-bottles")?.textContent
      || "";
    const trimmedTitle = title.trim();
    const plusMatch = trimmedTitle.match(/^\+\s*(\d+)\s*(.*)$/);
    if (plusMatch) {
      const count = plusMatch[1];
      const rest = plusMatch[2] || "";
      title = `${count}+${rest ? " " + rest : ""}`.trim();
    }
    const savings =
      activePlan.dataset?.planSavings
      || activePlan.querySelector(".lsg-bundle-v2-plan-savings")?.textContent
      || "";
    const badge =
      activePlan.dataset?.planBadge
      || activePlan.querySelector(".lsg-bundle-v2-plan-badge")?.textContent
      || "";

    const titleEl = summary.querySelector("[data-bundle-plan-summary-title]");
    const savingsEl = summary.querySelector("[data-bundle-plan-summary-savings]");
    const badgeEl = summary.querySelector("[data-bundle-plan-summary-badge]");

    if (titleEl) titleEl.textContent = title;
    if (savingsEl) {
      if (savings) {
        savingsEl.textContent = savings;
        summary.classList.add("has-savings");
      } else {
        savingsEl.textContent = "";
        summary.classList.remove("has-savings");
      }
    }
    if (badgeEl) {
      if (badge) {
        badgeEl.textContent = badge;
        summary.classList.add("has-badge");
      } else {
        badgeEl.textContent = "";
        summary.classList.remove("has-badge");
      }
    }

    if (typeof this.updateStickySummary === "function") {
      this.updateStickySummary();
    }
  }

  updateFlavorSelectionHelper() {
    const helper = this.querySelector("[data-bundle-flavor-selection-helper]");
    if (!helper) return;
    if (this.isV2MobileFlowEnabled()) {
      const selectedPaidSlots = [this.v2BundleSlots[0], this.v2BundleSlots[1]].filter(Boolean).length;
      const hasFreeGiftSelected = Boolean(this.v2BundleSlots[2]);
      let helperText = "Choose your flavor to unlock plan options.";

      if (!this.v2StructureChosen) {
        helperText = "Choose quantity to continue.";
      }

      if (this.v2StructureChosen && this.v2Mode === "bundle") {
        if (selectedPaidSlots <= 0) {
          helperText = "Select 2 flavors to unlock plan and checkout.";
        } else if (selectedPaidSlots === 1) {
          helperText = "1 of 2 selected. Choose 1 more flavor.";
        } else if (hasFreeGiftSelected) {
          helperText = "✓ Ready to checkout!";
        } else {
          helperText = "✓ Ready to checkout! Free gift is optional.";
        }
      } else if (this.v2StructureChosen && this.v2SingleVariantId) {
        helperText = "Flavor selected. Continue to plan.";
      }

      helper.textContent = helperText;
      helper.classList.toggle(
        "is-complete",
        this.v2StructureChosen
          && (this.v2Mode === "bundle" ? selectedPaidSlots >= 2 : Boolean(this.v2SingleVariantId)));
      helper.classList.toggle("is-near", this.v2StructureChosen && this.v2Mode === "bundle" && selectedPaidSlots === 1);
      const progress = this.querySelector("[data-bundle-flavor-progress]");
      if (progress) {
        progress.hidden = true;
      }
      return;
    }
    const progressSaveSteps = Array.from(
      this.querySelectorAll("[data-bundle-flavor-progress-save-step]"));
    const progress = this.querySelector("[data-bundle-flavor-progress]");
    const progressSegments = progress
      ? Array.from(progress.querySelectorAll("[data-bundle-flavor-progress-segment]"))
      : [];

    const selected = Math.max(0, this.getSelectedChildProductQty());
    const clamped = Math.min(selected, 3);

    let helperText = this.getBundleText("helperDefaultText", "Select 3 bottles to unlock max savings.");
    if (clamped === 1) {
      helperText = this.getBundleText("helperOneText", "Great choice! Add 1 more for extra savings.");
    } else if (clamped === 2) {
      helperText = this.getBundleText("helperTwoText", "Almost there! Add 1 more for max savings.");
    } else if (clamped >= 3) {
      helperText = this.getBundleText("helperCompleteText", "🎉 Awesome! Max Savings Unlocked.");
    }

    helper.textContent = helperText;
    helper.classList.toggle("is-complete", clamped >= 3);
    helper.classList.toggle("is-near", clamped === 2);
    const savePlanType = this.classList.contains("lsg-bundle-v2--otp-selected")
      ? "otp"
      : "sub";
    progressSaveSteps.forEach((stepEl, index) => {
      const stepFromData = Number(stepEl.dataset.bundleProgressStep);
      const step = Number.isFinite(stepFromData) && stepFromData > 0
        ? stepFromData
        : index + 1;
      const savePercent = this.getConfiguredDiscountPercent(savePlanType, step);
      stepEl.textContent = `${this.getBundleText("savePrefix", "Save")} ${savePercent}%`;
      stepEl.classList.toggle("is-active", clamped >= step);
    });

    if (progress) {
      progress.hidden = false;
      progress.setAttribute("aria-valuemin", "0");
      progress.setAttribute("aria-valuemax", "3");
      progress.setAttribute("aria-valuenow", String(clamped));
      progressSegments.forEach((segment, index) => {
        segment.classList.toggle("is-active", index < clamped);
      });
    }
  }

  updateStickySummary() {
    const summary = this.querySelector("[data-bundle-sticky-summary]");
    if (!summary) return;

    const activePlan = this.querySelector(".lsg-bundle-v2-plan-card.lsg-bundle-v2-size-select-el--selected")
      || this.querySelector(".lsg-bundle-v2-plan-card--featured")
      || this.querySelector(".lsg-bundle-v2-plan-card");
    if (!activePlan) return;

    let title =
      activePlan.dataset?.planTitle
      || activePlan.querySelector(".lsg-bundle-v2-plan-bottles")?.textContent
      || "";
    const trimmedTitle = title.trim();
    const plusMatch = trimmedTitle.match(/^\+\s*(\d+)\s*(.*)$/);
    if (plusMatch) {
      const count = plusMatch[1];
      const rest = plusMatch[2] || "";
      title = `${count}+${rest ? " " + rest : ""}`.trim();
    }

    const savings =
      activePlan.dataset?.planSavings
      || activePlan.querySelector(".lsg-bundle-v2-plan-savings")?.textContent
      || "";
    const planDaily = activePlan.dataset?.planDaily || "";
    const dailyText = planDaily
      ? planDaily.toLowerCase().includes("day")
        ? planDaily
        : `${planDaily} / day`
      : "";

    const countEl = summary.querySelector("[data-bundle-sticky-count]");
    const savingsEl = summary.querySelector("[data-bundle-sticky-savings]");
    const dailyEl = summary.querySelector("[data-bundle-sticky-daily]");

    if (countEl) countEl.textContent = title ? `${title} selected` : "";
    if (savingsEl) savingsEl.textContent = savings;
    if (dailyEl) dailyEl.textContent = dailyText;

    summary.classList.toggle("has-title", Boolean(title));
    summary.classList.toggle("has-savings", Boolean(savings));
    summary.classList.toggle("has-daily", Boolean(dailyText));
  }

  getStickyDiscountTier(selectedQuantity, planType = "sub") {
    const normalizedQty = Math.max(0, Math.min(3, Number(selectedQuantity) || 0));
    const tierPercents = [
      this.getConfiguredDiscountPercent(planType, 1),
      this.getConfiguredDiscountPercent(planType, 2),
      this.getConfiguredDiscountPercent(planType, 3),
    ];
    const unlockedPercent =
      normalizedQty <= 0
        ? tierPercents[0]
        : tierPercents[Math.min(3, normalizedQty) - 1];
    const nextPercent =
      normalizedQty >= 3
        ? null
        : tierPercents[Math.min(2, normalizedQty)];
    return {
      unlockedPercent,
      nextPercent,
      normalizedQty,
      isMinItemsStep: normalizedQty < 2,
      isMaxSavingsStep: normalizedQty >= 3,
      progressPercent: Math.min(100, Math.round((normalizedQty / 3) * 100)),
    };
  }

  requestStickyOfferBarUpdate(payload = {}) {
    const safePayload = payload && typeof payload === "object" ? payload : {};
    this.pendingStickyOfferPayload = {
      ...(this.pendingStickyOfferPayload || {}),
      ...safePayload,
    };
    if (this.stickyOfferRaf) return;

    this.stickyOfferRaf = window.requestAnimationFrame(() => {
      this.stickyOfferRaf = 0;
      const nextPayload = this.pendingStickyOfferPayload || {};
      this.pendingStickyOfferPayload = null;
      this.updateStickyOfferBar(nextPayload);
    });
  }

  updateStickyOfferBar({ otpSubtotal, subSubtotal, compareSubtotal, savingsSubtotal, otpDiscountPercent, subDiscountPercent } = {}) {
    if (!this.stickyBar) return;

    const selectedQuantity = this.getSelectedChildProductQty();
    const isActiveBundle = this.classList.contains("lsg-bundle-v2-block-active");
    const rect = this.getBoundingClientRect();
    const isInSectionViewport = rect.bottom > 0 && rect.top < window.innerHeight;
    const shouldDisplaySticky = isActiveBundle && isInSectionViewport;
    this.stickyBar.classList.toggle("is-active", shouldDisplaySticky);

    if (!shouldDisplaySticky) {
      if (this.stickyViewPanel) this.stickyViewPanel.hidden = true;
      if (this.stickyViewToggle) this.stickyViewToggle.setAttribute("aria-expanded", "false");
      this.stickyBar.classList.remove("is-expanded");
      this.lastStickyOfferSnapshot = "hidden";
      return;
    }

    const currentOtpSubtotal = Number.isFinite(otpSubtotal) ? otpSubtotal : this.lastOtpSubtotal;
    const currentSubSubtotal = Number.isFinite(subSubtotal) ? subSubtotal : this.lastSubSubtotal;
    const currentCompareSubtotal = Number.isFinite(compareSubtotal) ? compareSubtotal : this.lastCompareSubtotal;
    const isSubscription = this.classList.contains("lsg-bundle-v2--sub-selected");
    const currentOtpDiscountPercent = Number.isFinite(otpDiscountPercent)
      ? otpDiscountPercent
      : Number(this.lastOtpDiscountPercent || 0);
    const currentSubDiscountPercent = Number.isFinite(subDiscountPercent)
      ? subDiscountPercent
      : Number(this.lastSubDiscountPercent || 0);
    const currentSavingsSubtotal = Number.isFinite(savingsSubtotal)
      ? savingsSubtotal
      : Number(this.lastSavingsSubtotal || 0);
    const selectedDiscountPercent = isSubscription ? currentSubDiscountPercent : currentOtpDiscountPercent;
    const tierData = this.getStickyDiscountTier(
      selectedQuantity,
      isSubscription ? "sub" : "otp");

    const stickySnapshot = [
      selectedQuantity,
      isSubscription ? "sub" : "otp",
      currentOtpSubtotal,
      currentSubSubtotal,
      currentCompareSubtotal,
      currentSavingsSubtotal,
      currentOtpDiscountPercent,
      currentSubDiscountPercent,
      tierData.normalizedQty,
    ].join("|");
    if (stickySnapshot === this.lastStickyOfferSnapshot) return;
    this.lastStickyOfferSnapshot = stickySnapshot;

    const discountedTotal = isSubscription ? currentSubSubtotal : currentOtpSubtotal;
    const currency = Shopify?.currency?.active || "USD";
    const currencyFormatter = new Intl.NumberFormat("en-US", {
      currency,
      style: "currency",
    });
    const youSavePrefix = this.getBundleText("youSavePrefix", "YOU SAVE");
    const savePrefix = this.getBundleText("savePrefix", "Save");
    const offUnlockedSuffix = this.getBundleText("offUnlockedSuffix", "OFF UNLOCKED");
    const standardPriceText = this.getBundleText("standardPriceText", "Standard Price");
    const selectFlavorText = this.getBundleText("selectFlavorText", "SELECT A FLAVOR");
    const unlockedText = (percentValue) => `${Math.max(0, Number(percentValue) || 0)}% ${offUnlockedSuffix}`.trim();

    if (this.stickyTotalEl) {
      this.stickyTotalEl.textContent = currencyFormatter.format(discountedTotal / 100);
    }

    if (this.stickyCompareTotalEl) {
      this.stickyCompareTotalEl.textContent = currentCompareSubtotal > discountedTotal
        ? currencyFormatter.format(currentCompareSubtotal / 100)
        : "";
    }

    if (this.stickySaveEl) {
      this.stickySaveEl.textContent = currentSavingsSubtotal > 0
        ? `${youSavePrefix} ${currencyFormatter.format(currentSavingsSubtotal / 100)}`
        : "";
    }

    if (this.stickySubSaveEls?.length) {
      const stickySaveLabel = currentSubDiscountPercent > 0
        ? `${savePrefix} ${currentSubDiscountPercent}%`
        : savePrefix;
      this.stickySubSaveEls.forEach((el) => {
        el.textContent = stickySaveLabel;
      });
    }

    if (this.stickyUnlockedEl) {
      if (!isSubscription) {
        if (selectedQuantity <= 1) {
          this.stickyUnlockedEl.textContent = standardPriceText;
        } else {
          this.stickyUnlockedEl.textContent = unlockedText(currentOtpDiscountPercent);
        }
      } else {
        this.stickyUnlockedEl.textContent = selectedQuantity > 0
          ? unlockedText(selectedDiscountPercent)
          : selectFlavorText;
      }
    }

    if (this.stickyProgressEls?.length) {
      this.stickyProgressEls.forEach((segment, index) => {
        segment.classList.toggle("is-active", index < tierData.normalizedQty);
      });
    }
  }

  showRequiredMessage() {
    if (this.isV2MobileFlowEnabled()) {
      if (!this.v2StructureChosen) {
        const structureStep = this.querySelector(".lsg-bundle-v2-mobile-step--structure");
        structureStep?.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
      if (this.v2Mode === "bundle") {
        this.v2SlotStep?.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
      if (this.v2Mode === "single") {
        this.v2FlavorStep?.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
    }

    const flavorsCard = this.querySelector(".lsg-bundle-v2-flavors-card");
    if (!flavorsCard) return;

    const messageEl = flavorsCard.querySelector("[data-bundle-required-message]");
    if (messageEl) {
      const required = this.getCheckoutRequiredQuantity();
      messageEl.textContent = required <= 1
        ? this.getBundleText("requiredFlavorText", "Please choose a flavor.")
        : this.getBundleText("requiredFlavorsText", "Please choose {count} flavors.")
          .replaceAll("{count}", String(required));
      messageEl.hidden = false;
    }

    flavorsCard.classList.add("is-required");
    flavorsCard.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  clearRequiredMessage() {
    const flavorsCard = this.querySelector(".lsg-bundle-v2-flavors-card");
    if (!flavorsCard) return;

    const messageEl = flavorsCard.querySelector("[data-bundle-required-message]");
    if (messageEl) {
      messageEl.textContent = "";
      messageEl.hidden = true;
    }

    flavorsCard.classList.remove("is-required");
  }

  getBundleFlavorLabelByVariantId(variantId) {
    const normalizedVariantId = String(variantId || "").trim();
    if (!normalizedVariantId) return "";
    const card = this.querySelector(
      `.lsg-bundle-v2-product-select-wrapper[data-lsg-bundle-v2-variant-select-id="${normalizedVariantId}"]`);
    if (!card) return "";
    const datasetTitle = String(card.dataset?.bundleCardTitle || "").trim();
    if (datasetTitle) return datasetTitle;
    const titleElement = card.querySelector(".lsg-bundle-v2-product-select-title");
    return String(titleElement?.textContent || "").trim();
  }

  buildBundleFlavorSummary(selectedInputs = []) {
    const safeInputs = Array.isArray(selectedInputs) ? selectedInputs : [];
    const summaryParts = safeInputs
      .map((input) => {
        const variantId = String(input?.dataset?.product || "").trim();
        const quantity = Number(input?.value || 0);
        if (!variantId || !Number.isFinite(quantity) || quantity <= 0) return "";
        const flavorLabel = this.getBundleFlavorLabelByVariantId(variantId);
        if (!flavorLabel) return "";
        return `${flavorLabel} x${quantity}`;
      })
      .filter(Boolean);
    return summaryParts.join(", ");
  }

  resolveOneTimeVariantId(bundleInput) {
    const currentVariantId = String(bundleInput?.dataset?.product || "").trim();
    if (!currentVariantId) return "";

    const requiresSellingPlanRaw = String(bundleInput?.dataset?.requiresSellingPlan || "")
      .trim()
      .toLowerCase();
    const requiresSellingPlan = requiresSellingPlanRaw === "true" || requiresSellingPlanRaw === "1";
    if (!requiresSellingPlan) return currentVariantId;

    const sourceCard = bundleInput.closest(".lsg-bundle-v2-product-select-wrapper");
    const sourceFlavor = String(sourceCard?.dataset?.flavor || "").trim().toLowerCase();
    const sourceTitle = String(sourceCard?.dataset?.bundleCardTitle || "").trim().toLowerCase();
    const sourceProductId = String(
      sourceCard?.dataset?.bundleProductId || bundleInput?.dataset?.bundleProductId || "").trim();

    const candidateInputs = Array.from(this.querySelectorAll(".stay-ai-bundle-product-v2__quantity"))
      .filter((candidateInput) => {
        const candidateVariantId = String(candidateInput?.dataset?.product || "").trim();
        if (!candidateVariantId || candidateVariantId === currentVariantId) return false;
        const candidateRequiresRaw = String(candidateInput?.dataset?.requiresSellingPlan || "")
          .trim()
          .toLowerCase();
        const candidateRequiresSellingPlan =
          candidateRequiresRaw === "true" || candidateRequiresRaw === "1";
        return candidateRequiresSellingPlan === false;
      })
      .map((candidateInput) => {
        const candidateCard = candidateInput.closest(".lsg-bundle-v2-product-select-wrapper");
        const candidateFlavor = String(candidateCard?.dataset?.flavor || "")
          .trim()
          .toLowerCase();
        const candidateTitle = String(candidateCard?.dataset?.bundleCardTitle || "")
          .trim()
          .toLowerCase();
        const candidateProductId = String(
          candidateCard?.dataset?.bundleProductId || candidateInput?.dataset?.bundleProductId || "").trim();

        let score = 0;
        if (sourceProductId && candidateProductId && sourceProductId === candidateProductId) score += 8;
        if (sourceFlavor && candidateFlavor && sourceFlavor === candidateFlavor) score += 4;
        if (sourceTitle && candidateTitle && sourceTitle === candidateTitle) score += 2;

        return {
          input: candidateInput,
          score,
        };
      })
      .sort((a, b) => b.score - a.score);

    const bestCandidate = candidateInputs[0];
    const bestVariantId = String(bestCandidate?.input?.dataset?.product || "").trim();
    if (!bestVariantId) return currentVariantId;

    return bestVariantId;
  }

  resetAllBundleBlocksAfterAdd() {
    const bundleWrapper = this.closest(".lsg-bundle-v2-wrapper");
    const bundleBlocks = bundleWrapper
      ? Array.from(bundleWrapper.querySelectorAll("stay-ai-bundle-product-v2.lsg-bundle-v2-block"))
      : [this];

    bundleBlocks.forEach((bundleBlock) => {
      if (!bundleBlock) return;
      if (typeof bundleBlock.resetBundleSelections === "function") {
        bundleBlock.resetBundleSelections({ clearUrl: false });
      }
      const intervalInputs = Array.from(
        bundleBlock.querySelectorAll(
          '.lsg-bundle-v2-interval-select input[name^="bundle_interval_select_"]'));
      const defaultIntervalInput =
        intervalInputs.find((input) => input.defaultChecked) || intervalInputs[0] || null;
      if (defaultIntervalInput) {
        defaultIntervalInput.checked = true;
        if (typeof bundleBlock.updateInterval === "function") {
          bundleBlock.updateInterval(defaultIntervalInput);
        }
      }

      const frequencySelect = bundleBlock.querySelector(".lsg-bundle-v2-interval-frequency-select");
      if (frequencySelect) {
        const defaultOption =
          Array.from(frequencySelect.options || []).find((option) => option.defaultSelected) ||
          frequencySelect.options?.[0] ||
          null;
        if (defaultOption) {
          frequencySelect.value = defaultOption.value;
        }
        if (typeof bundleBlock.updateFrequency === "function") {
          bundleBlock.updateFrequency(frequencySelect);
        }
      }

      if (typeof bundleBlock.clearPersistedBundleState === "function") {
        bundleBlock.clearPersistedBundleState();
      }
      if (typeof bundleBlock.updateStickyObserverState === "function") {
        bundleBlock.updateStickyObserverState();
      }
    });

    if (bundleBlocks.length > 0 && typeof bundleBlocks[0].clearBundleParams === "function") {
      bundleBlocks[0].clearBundleParams();
    } else {
      this.clearBundleParams();
    }
  }

  /**
   * Add to bundled products to cart
   */
  addToCart() {
    if (this.isAddingToCart) return false;
    this.closeProductModal();

    const bundleID = this.getGuid();
    const bundleForm =
      this.querySelector('form.lsg-bundle-v2-form') || this.querySelector('.lsg-bundle-v2-form');
    const submitButton = this.querySelector('.lsg-bundle-v2-submit-button');
    const bundleProductList = this.querySelector('.stay-ai-bundle-product-v2__cards');
    const bundleProductListInputs = bundleProductList.querySelectorAll('.stay-ai-bundle-product-v2__quantity');
    const bundleSelectedProducts = [...bundleProductListInputs].filter( (list) => list.value > 0);
    let bundleProductQuantity = bundleSelectedProducts.reduce((acc, curr) => acc + Number(curr.value), 0);
    const bundleFlavorSummary = this.buildBundleFlavorSummary(bundleSelectedProducts);

    const quantityTierBundleBlock = this.resolveBundleBlockForQuantity(bundleProductQuantity) || this;
    const isSubscriptionSelection =
      this.getBundleInterval(this) === "sub" || this.classList.contains("lsg-bundle-v2--sub-selected");
    const selectedBundleBlock =
      this.resolveSubscriptionParentBundleBlock() || quantityTierBundleBlock || this;
    const selectedBundleForm =
      selectedBundleBlock.querySelector('form.lsg-bundle-v2-form')
      || selectedBundleBlock.querySelector('.lsg-bundle-v2-form')
      || bundleForm;
    const defaultBundleParentId = String(
      selectedBundleForm.querySelector('input[name="id"]')?.value
      || bundleForm?.querySelector('input[name="id"]')?.value
      || "").trim();
    const otpBundleParentId = String(
      selectedBundleForm.dataset?.bundleParentOtpVariantId
      || bundleForm?.dataset?.bundleParentOtpVariantId
      || defaultBundleParentId).trim();
    const subBundleParentId = String(
      selectedBundleForm.dataset?.bundleParentSubVariantId
      || bundleForm?.dataset?.bundleParentSubVariantId
      || defaultBundleParentId).trim();
    const bundleProductID = isSubscriptionSelection ? subBundleParentId : otpBundleParentId;
    if (!bundleProductID) {
      this.isAddingToCart = false;
      this.setAtcProgressState("idle");
      return false;
    }
    const selectionRequiresSellingPlan = this.requiresSellingPlanForSelection(
      bundleSelectedProducts,
      selectedBundleBlock);
    const selectedSubscriptionPlan = this.getSellingPlanForBundle(selectedBundleBlock, this);
    const fallbackSellingPlan = this.getFallbackSellingPlanForBundle(selectedBundleBlock, this);
    const bundleSellingPlan = isSubscriptionSelection
      ? (selectedSubscriptionPlan || (selectionRequiresSellingPlan ? fallbackSellingPlan : ""))
      : "";
    const selectedBundleMax = Number(selectedBundleBlock?.bundleMax);
    const blockBundleMax = Number(this.bundleMax);
    const effectiveBundleMin = this.getCheckoutRequiredQuantity();
    const effectiveBundleMax =
      Number.isFinite(selectedBundleMax) && selectedBundleMax > 0
        ? selectedBundleMax
        : Number.isFinite(blockBundleMax) && blockBundleMax > 0
          ? blockBundleMax
          : 100;

    const exceedsBundleMax = effectiveBundleMax > 0 && bundleProductQuantity > effectiveBundleMax;
    if (exceedsBundleMax || bundleProductQuantity < effectiveBundleMin) {
      return false;
    }

    this.isAddingToCart = true;
    this.setAtcProgressState("adding");

    const childSelections = bundleSelectedProducts.map((bundleProduct) => {
      const originalChildVariantId = String(bundleProduct?.dataset?.product || "").trim();
      const childVariantId = isSubscriptionSelection
        ? originalChildVariantId
        : this.resolveOneTimeVariantId(bundleProduct);
      const requiresSellingPlanRaw = String(bundleProduct?.dataset?.requiresSellingPlan || "")
        .trim()
        .toLowerCase();
      const childRequiresSellingPlan =
        (requiresSellingPlanRaw === "true" || requiresSellingPlanRaw === "1")
        && childVariantId === originalChildVariantId;
      return {
        id: childVariantId,
        quantity: parseInt(bundleProduct.value),
        requiresSellingPlan: childRequiresSellingPlan,
      };
    });

    const cartItems = childSelections.map((selection) => {
      const item = {
        id: selection.id,
        quantity: selection.quantity,
        properties: {
          _bundle_id: bundleID,
        },
      };
      if (bundleSellingPlan) {
        item.selling_plan = bundleSellingPlan;
      }
      return item;
    });

    let bundleCart = {
      items: [
        {
          id: bundleProductID,
          quantity: 1,
          properties: {
            _bundle_id: bundleID,
            _bundle_parent: "true",
            _bundle_max: effectiveBundleMax,
            _bundle_min: effectiveBundleMin,
            ...(bundleFlavorSummary
              ? { [this.getBundleText("bundleFlavorsPropertyLabel", "Bundle flavors")]: bundleFlavorSummary }
              : {}),
          },
        },
        ...cartItems,
      ],
    };
    if (bundleSellingPlan) {
      bundleCart.items[0].selling_plan = bundleSellingPlan;
    }

    let drawer = document.querySelector('stay-ai-cart-drawer') || document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      bundleCart.sections = drawer.getSectionsToRender().map((section) => section.id);
      bundleCart.sections_url = window.location.pathname;
    }

    const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    const normalizedRootPath = rootPath.endsWith("/") ? rootPath : `${rootPath}/`;
    const addEndpoint = `${normalizedRootPath}cart/add.js`;

    const addBundleToCart = async () => {
      const requestPayloads = [];
      const seenPayloadSignatures = new Set();
      const payloadSignature = (payload) => {
        const items = Array.isArray(payload?.items) ? payload.items : [];
        return items
          .map((item, index) => `${index}:${item?.id || ""}:${item?.quantity || 0}:${item?.selling_plan || ""}`)
          .join("|");
      };
      const queuePayload = (payload) => {
        if (!payload || !Array.isArray(payload.items) || !payload.items.length) return;
        const signature = payloadSignature(payload);
        if (seenPayloadSignatures.has(signature)) return;
        seenPayloadSignatures.add(signature);
        requestPayloads.push(payload);
      };

      queuePayload(bundleCart);

      // Some stores reject selling plan ids on child items even when parent plan is valid.
      if (bundleSellingPlan) {
        const parentPlanOnlyPayload = {
          ...bundleCart,
          items: bundleCart.items.map((item, index) => {
            const nextItem = { ...item };
            if (index > 0 && Object.prototype.hasOwnProperty.call(nextItem, "selling_plan")) {
              delete nextItem.selling_plan;
            }
            return nextItem;
          }),
        };
        queuePayload(parentPlanOnlyPayload);
      } else if (!isSubscriptionSelection) {
        const parentRequiresSellingPlanRaw = String(
          selectedBundleForm?.dataset?.bundleParentRequiresPlan
          || selectedBundleBlock?.dataset?.bundleParentRequiresPlan
          || this.dataset?.bundleParentRequiresPlan
          || "")
          .trim()
          .toLowerCase();
        const parentRequiresSellingPlan =
          parentRequiresSellingPlanRaw === "true" || parentRequiresSellingPlanRaw === "1";
        const oneTimeFallbackPlan = this.getFallbackSellingPlanForBundle(selectedBundleBlock, this);

        if (oneTimeFallbackPlan) {
          const selectiveFallbackPayload = {
            ...bundleCart,
            items: bundleCart.items.map((item, index) => {
              const nextItem = { ...item };
              if (index === 0 && parentRequiresSellingPlan) {
                nextItem.selling_plan = oneTimeFallbackPlan;
              } else if (index > 0 && childSelections[index - 1]?.requiresSellingPlan) {
                nextItem.selling_plan = oneTimeFallbackPlan;
              }
              return nextItem;
            }),
          };
          queuePayload(selectiveFallbackPayload);

          const parentOnlyFallbackPayload = {
            ...bundleCart,
            items: bundleCart.items.map((item, index) => {
              const nextItem = { ...item };
              if (index === 0) {
                nextItem.selling_plan = oneTimeFallbackPlan;
              }
              return nextItem;
            }),
          };
          queuePayload(parentOnlyFallbackPayload);

          const allItemsFallbackPayload = {
            ...bundleCart,
            items: bundleCart.items.map((item) => ({
              ...item,
              selling_plan: oneTimeFallbackPlan,
            })),
          };
          queuePayload(allItemsFallbackPayload);
        }
      }

      let cartResponse = null;
      let usedPayload = bundleCart;
      let lastError = null;

      for (const requestPayload of requestPayloads) {
        try {
          const response = await fetch(addEndpoint, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
            body: JSON.stringify(requestPayload),
            credentials: "same-origin",
          });
          const data = await response.json().catch(() => ({}));
          if (!response.ok) {
            const errorMessage =
              data?.description ||
              data?.message ||
              `Cart add failed (${response.status})`;
            const error = new Error(errorMessage);
            error.status = response.status;
            throw error;
          }
          cartResponse = data;
          usedPayload = requestPayload;
          break;
        } catch (error) {
          lastError = error;
          const payloadSummary = Array.isArray(requestPayload?.items)
            ? requestPayload.items.map((item, index) => ({
              index,
              id: String(item?.id || ""),
              quantity: Number(item?.quantity || 0),
              selling_plan: String(item?.selling_plan || ""),
              is_bundle_parent: Boolean(item?.properties?._bundle_parent),
            }))
            : [];
          console.error("[Bundle Builder] Add to cart attempt failed:", error, payloadSummary);
        }
      }

      if (!cartResponse) {
        throw lastError || new Error("Cart add failed");
      }

      this.setStickyAtcHidden(true);
      this.invalidateCartSnapshotCache();
      this.resetAllBundleBlocksAfterAdd();
      this.trackBundleAddToCart(usedPayload);
      this.dispatchEvent(
        new CustomEvent("cart-drawer:refresh", {
          detail: { response: cartResponse },
          bubbles: true,
          composed: true,
        }));
    };

    addBundleToCart()
      .then(() => {
        if (this.atcProgressTimer) {
          window.clearTimeout(this.atcProgressTimer);
          this.atcProgressTimer = 0;
        }
        this.setAtcProgressState("added");
        this.atcProgressTimer = window.setTimeout(() => {
          this.atcProgressTimer = 0;
          this.setAtcProgressState("idle");
        }, 1300);

        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer?.isOpen) return;

        const cartTrigger = document.querySelector(".wt-cart__trigger");
        if (cartTrigger) {
          cartTrigger.click();
          return;
        }

        if (
          cartDrawer
          && typeof cartDrawer.toggleDrawerClasses === "function"
        ) {
          cartDrawer.toggleDrawerClasses();
        }
      })
      .catch((error) => {
        console.error("[Bundle Builder] Add to cart failed:", error);
        if (this.atcProgressTimer) {
          window.clearTimeout(this.atcProgressTimer);
          this.atcProgressTimer = 0;
        }
        this.setAtcProgressState("idle");
      })
      .finally(() => {
        this.isAddingToCart = false;
      });
  }

  trackBundleAddToCart(bundleCart) {
    try {
      const items = Array.isArray(bundleCart?.items) ? bundleCart.items : [];
      const signature = items
        .map((item) => `${item.id}:${Number(item.quantity) || 0}`)
        .join("|");
      const now = Date.now();
      const duplicateWindowMs = 1500;
      const signatureKey = BUNDLE_V2_ATC_DEDUPE_KEYS.signature;
      const timeKey = BUNDLE_V2_ATC_DEDUPE_KEYS.time;

      if (
        window[signatureKey] === signature &&
        now - (window[timeKey] || 0) < duplicateWindowMs
      ) {
        return;
      }

      window[signatureKey] = signature;
      window[timeKey] = now;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          currency:
            window.Shopify?.currency?.active ||
            window.Shopify?.currency?.shopCurrency ||
            "",
          items: items.map((item) => ({
            item_id: String(item.id),
            quantity: Number(item.quantity) || 0,
          })),
        },
      });
    } catch (error) {
      console.error("Bundle GTM add_to_cart tracking error:", error);
    }
  }

  getBundleParentVariantId() {
    const bundleForm = this.querySelector('.lsg-bundle-v2-form');
    const input = bundleForm?.querySelector('input[name="id"]');
    return input ? String(input.value) : "";
  }

  setStickyAtcHidden(isHidden) {
    this.classList.remove("bundle-in-cart");
  }

  checkStickyAtcVisibility({ forceRefresh = false } = {}) {
    const bundleVariantId = this.getBundleParentVariantId();
    if (!bundleVariantId) return;

    this.getCartSnapshot({ forceRefresh })
      .then((cart) => {
        const hasBundle = Boolean(this.getBundleParentItemFromCart(cart));
        this.setStickyAtcHidden(hasBundle);
      })
      .catch(() => {});
  }

  /**
   * Update selling plan price and id
   * @param {HTMLElement} trigger
   */
  updateFrequency(trigger) {
    //Render price and assign selling_plan in the form
    const frequencySelect = this.getFrequencySelect(trigger);
    if (frequencySelect) {
      this.syncFrequencySelects(frequencySelect.value);
    }
    this.updateBundlePrice(frequencySelect || trigger);
    this.updateSellingPlan(frequencySelect || trigger);
    this.persistBundleState();
  }

  /**
   * Updates bundle block classes, resets displayed prices, and sets the selling_plan input value
   * @param {HTMLElement} trigger
   */
  updateInterval(trigger) {
    const bundleBlock = this.getBundleBlock(trigger);
    const sellingPlanInput = bundleBlock.querySelector('.lsg-bundle-v2-form input[name="selling_plan"]');
    const frequencySelect = bundleBlock.querySelector('.lsg-bundle-v2-interval-frequency-select');

    switch(trigger.value) {
      case 'otp':
        bundleBlock.classList.remove('lsg-bundle-v2--sub-selected');
        bundleBlock.classList.add('lsg-bundle-v2--otp-selected');
        sellingPlanInput.value = '';
        break;
      case 'sub':
        bundleBlock.classList.remove('lsg-bundle-v2--otp-selected');
        bundleBlock.classList.add('lsg-bundle-v2--sub-selected');
        sellingPlanInput.value = frequencySelect.value;
        break;
    }

    this.updateBundlePrice(trigger);
    this.updateSellingPlan(trigger);
    this.persistBundleState();
  }

   /**
   * Update selected selling plan value
   */
  updateSellingPlan(trigger) {
    const sellingPlan = this.querySelector('.lsg-bundle-v2-form input[name="selling_plan"]');
    
    if (!sellingPlan) return;
    if (!this.classList.contains('lsg-bundle-v2--sub-selected')) {
      sellingPlan.value = "";
      return;
    }

    const frequencySelect = this.getFrequencySelect(trigger);
    sellingPlan.value = frequencySelect ? frequencySelect.value : "";
  }

  /**
   * Load observer for mobile fixed ATC
   */
  loadBundleObserver() {
    const bundleObserver = new IntersectionObserver(([entry]) => {
    const bundleBlock = entry.target.closest('.lsg-bundle-v2-block');
    
    if (!bundleBlock) return

    bundleBlock.classList.remove('summary-is-below', 'summary-is-above', 'summary-is-visible');

    if (entry.isIntersecting) {
      bundleBlock.classList.add('summary-is-visible');
      return
    }

    entry.boundingClientRect.top > 0 ? bundleBlock.classList.add('summary-is-below') : bundleBlock.classList.add('summary-is-above');
  });
  const buyboxes = document.querySelectorAll('.lsg-bundle-v2-summary-block');
  buyboxes.forEach((buybox) => {
      bundleObserver.observe(buybox);
  });
  }

  updateStickyObserverState() {
    const summary = this.querySelector(".lsg-bundle-v2-summary-block");
    if (!summary) return;

    this.classList.remove("summary-is-below", "summary-is-above", "summary-is-visible");

    const rect = summary.getBoundingClientRect();
    const isIntersecting = rect.bottom > 0 && rect.top < window.innerHeight;
    if (isIntersecting) {
      this.classList.add("summary-is-visible");
      return;
    }

    rect.top > 0
      ? this.classList.add("summary-is-below")
      : this.classList.add("summary-is-above");
  }
}
if (!customElements.get("stay-ai-bundle-product-v2")) {
  customElements.define("stay-ai-bundle-product-v2", StayAIBundleProduct);
}
